<template>
  <div style="height: 100vh;" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div :activeIndex="activeIndex">
      <GlobalHeader style="position: absolute;"/>
      <el-container>
        <el-main>
          <div
              style="position: fixed;z-index: 111; background: #fff;width: calc(100% - 175px); min-width:1200px;left:175px">
            <div class="edit">
              <div class="fl" style="justify-content: space-between; margin-left: 6px;">
                <span style="width: 63px; background-color: #589ff9;border: 1px solid #589ff9;"
                      @click="openChildDialog(1)">
                  <img src="../images/increase.png" style="width: 15px; height: 15px" alt=""/>
                </span>

              </div>
              <div @click="dialogVisible = true"
                   style="    width: 80px;height: 25px;cursor: pointer;display: flex;border: 1px solid #589ff9;margin-left:10px;justify-content: center;border-radius: 5px;">
                <span style="font-size: 14px;">filter</span>
              </div>
              <!-- <span style="width: 69px;border: 1px solid #589ff9; margin-left: 5px;" @click="cleanUpEvt">ALL</span> -->


              <el-input placeholder="项目名称" v-model="name" @change="getList" v-if="name"
                        :class="{ 'vip': name && name.length != '0' }" clearable @click="disabled = !disabled">
              </el-input>

              <el-input placeholder="客户名称" v-model="customer" @change="getList" v-if="roles == 5 ? false : true "
                        v-show="customer" :class="{ 'vip': customer && customer.length != '0' }" clearable>
              </el-input>

              <el-cascader @change="status_box" v-model="status" placeholder="项目进度" :options="options2" filterable
                           clearable :class="{ 'vip': status && status !== '项目进度' }" v-if="status">
              </el-cascader>
              <el-select v-if="pdf" v-model="pdf" style="width: 180px;height: 40px;margin-left: 10px;" clearable
                         :class="{ 'vip': pdf }"
                         @change="pdfChange">
                <el-option clearable v-for="item in options4" :key="item.value" :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
              <el-select v-show="invoice" v-model="invoice" style="width: 180px;height: 40px;margin-left: 10px;"
                         clearable :class="{ 'vip': invoice }"
                         v-if="roles == 5 ? false : true " @change="invoiceChange">
                <el-option clearable v-for="item in options5" :key="item.value" :label="item.label"
                           :value="item.value"></el-option>
              </el-select>


              <el-select class="tagEv" v-model="back_status" style="margin-left:6px;" multiple placeholder="回款情况"
                         v-show="back_status && back_status.length > 0" v-if="roles !== 5"
                         @change="handleSelectionChange"
                         collapse-tags>
                <el-option clearable v-for="item in options3" :key="item.value" :label="item.label" :value="item.value"
                           :class="{ 'vip': back_status && back_status.length > 0 }"></el-option>
              </el-select>


              <el-select v-model="sign" filterable placeholder="签单人" @change="signChange" style="margin-left: 6px;"
                         v-show="sign" v-if="roles == 5 ? false : true " clearable
                         :class="{ 'vip': sign && sign !== '签单人' }">
                <el-option v-for="(item, index) in set_of" :key="index" :label="item.name" :value="item.id">
                </el-option>
              </el-select>

              <el-select v-model="assistant" filterable placeholder="维护人" @change="assistantChange"
                         v-show="assistant"
                         v-if="roles == 5 ? false : true " style="margin-left: 6px;" clearable
                         :class="{ 'vip': assistant && assistant !== '维护人' }">
                <el-option v-for="(item, index) in assistant_id" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>

              <el-select v-model="first_sales" filterable placeholder="开发人" @change="first_salesChange"
                         v-show="first_sales"
                         v-if="roles == 5 ? false : true " style="margin-left: 6px;" clearable
                         :class="{ 'vip': first_sales && first_sales !== '开发人' }">
                <el-option v-for="(item, index) in first_sales_id" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>


              <el-select v-model="charge_id" filterable placeholder="翻译" @change="charge_idChange" v-if="charge_id"
                         style="margin-left: 6px;" clearable :class="{ 'vip': charge_id && charge_id !== '翻译' }">
                <el-option v-for="(item, index) in charge" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>

              <el-select v-model="group_one" filterable placeholder="小组" @change="groupChange"
                         style="margin-left: 6px;"
                         v-if="group_one" clearable :class="{ 'vip': group_one && group_one !== '小组' }">
                <el-option v-for="(item, index) in group" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <el-input placeholder="进度备注" v-model="progress_remark" @change="getList" clearable
                        v-if="progress_remark"
                        :class="{ 'vip': progress_remark && progress_remark.length != '0' }">
              </el-input>
              <el-input placeholder="制作备注" v-model="content_remark" @change="getList" clearable
                        v-if="content_remark"
                        :class="{ 'vip': content_remark && content_remark.length != '0' }">
              </el-input>
              <el-input placeholder="回款备注" v-model="refund_remark" @change="getList" clearable
                        v-show="refund_remark"
                        v-if="roles == 5 ? false : true "
                        :class="{ 'vip': refund_remark && refund_remark.length != '0' }">
              </el-input>

              <el-popover placement="top" width="350" v-model="visible">
                <Tanchu @handle-click="getTimestamp('1', $event)"/>
                <div style="display:flex;justify-content: space-evenly;padding: 10px 0 10px;">

                  <el-date-picker v-model="value3_1" type="date" placeholder="之前"></el-date-picker>

                  <el-date-picker v-model="value3" type="date" placeholder="之后"></el-date-picker>
                </div>
                <hr style="border-color: #fff;"/>
                <div style="text-align: right; margin: 0;margin-right:15px;margin-top:20px">
                  <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="queren_E">确定</el-button>
                </div>
                <!-- 开工时间 -->
                <el-input slot="reference" :class="{ 'dynamic-background': isDynamicBackground }"
                          :placeholder="value3_1 || value3 ? (value3_1 ? formatDate(value3_1) : '') + (value3 ? ('--' + formatDate(value3)) : '') : (startDate0 && endDate0 ? startDate0 + '--' + endDate0 : '开工时间')"
                          v-if="startDate0 || endDate0 ">
                  <template slot="suffix">
                    <i class="el-input__icon el-icon-circle-close" @click="clearInput(1)"></i>
                  </template>
                </el-input>
              </el-popover>


              <el-popover placement="top" width="350" v-model="visible_1">
                <Tanchu @handle-click="getTimestamp('2', $event)"/>
                <div style="display:flex;justify-content: space-evenly;padding: 10px 0 10px;">
                  <el-date-picker v-model="value2_1" type="date" placeholder="之前"></el-date-picker>
                  <el-date-picker v-model="value2" type="date" placeholder="之后"></el-date-picker>
                </div>
                <hr style="border-color: #fff;"/>
                <div style="text-align: right; margin: 0;margin-right:15px;margin-top:20px">
                  <el-button size="mini" type="text" @click="visible_1 = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="queren_Ev">确定</el-button>
                </div>
                <!-- placeholder="要求完工" -->
                <el-input slot="reference" :class="{ 'dynamic-background': isDynamicBackground1 }"
                          :placeholder="value2_1 || value2 ? (value2_1 ? formatDate(value2_1) : '') + (value2 ? ('--' + formatDate(value2)) : '') : (startDate1 && endDate1 ? startDate1 + '--' + endDate1 : '要求完工')"
                          v-if="startDate1 || endDate1 ">
                  <template slot="suffix">
                    <i class="el-input__icon el-icon-circle-close" @click="clearInput(2)"></i>
                  </template>
                </el-input>
              </el-popover>


              <el-popover placement="top" width="350" v-model="visible_2">
                <Tanchu @handle-click="getTimestamp('3', $event)"/>
                <div style="display:flex;justify-content: space-evenly;padding: 10px 0 10px;">
                  <el-date-picker v-model="value1_1" type="date" placeholder="之前"></el-date-picker>
                  <el-date-picker v-model="value1" type="date" placeholder="之后"></el-date-picker>
                </div>
                <hr style="border-color: #fff;"/>
                <div style="text-align: right; margin: 0;margin-right:15px;margin-top:20px">
                  <el-button size="mini" type="text" @click="visible_2 = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="queren_Evt">确定</el-button>
                </div>
                <!-- 实际完工 -->
                <el-input slot="reference" :class="{ 'dynamic-background': isDynamicBackground2 }"
                          :placeholder="value1_1 || value1 ? (value1_1 ? formatDate(value1_1) : '') + (value1 ? ('--' + formatDate(value1)) : '') : (startDate2 && endDate2 ? startDate2 + '--' + endDate2 : '实际完工')"
                          v-if="startDate2 || endDate2 ">
                  <template slot="suffix">
                    <i class="el-input__icon el-icon-circle-close" @click="clearInput(3)"></i>
                  </template>
                </el-input>
              </el-popover>
              <el-popover placement="top" width="350" v-model="visible_3">
                <Tanchu @handle-click="getTimestamp('4', $event)"/>
                <div style="display:flex;justify-content: space-evenly;padding: 10px 0 10px;">
                  <el-date-picker v-model="value0_1" type="date" placeholder="之前"></el-date-picker>
                  <el-date-picker v-model="value0" type="date" placeholder="之后"></el-date-picker>
                </div>
                <hr style="border-color: #fff;"/>

                <div style="text-align: right; margin: 0;margin-right:15px;margin-top:20px">
                  <el-button size="mini" type="text" @click="visible_3 = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="queren_Evte">确定</el-button>
                </div>
                <template slot="reference">
                  <el-input :class="{ 'dynamic-background': isDynamicBackground3 }"
                            v-if="roles != 5 && (startDate3 || endDate3)"
                            :placeholder="value0_1 || value0 ? (value0_1 ? formatDate(value0_1) : '') + (value0 ? ('--' + formatDate(value0)) : '') : (startDate3 && endDate3? startDate3 + '--' + endDate3: '回款时间')">
                    <template slot="suffix">
                      <i class="el-input__icon el-icon-circle-close" @click="clearInput(4)"></i>
                    </template>
                  </el-input>
                </template>
              </el-popover>

              <el-cascader @change="customer_box" v-model="region" popper-class='custom_box' placeholder="客户区域"
                           v-if="roles == 5 ? false : true " :options="options" filterable clearable v-show="region"
                           :class="{ 'vip': region && region !== '客户区域' }">
              </el-cascader>
              <el-select v-model="type_id" filterable placeholder="客户类型" @change="Customer_type"
                         style="margin-left: 6px;"
                         v-if="type_id" clearable :class="{ 'vip': type_id && type_id !== '客户类型' }">
                <el-option v-for="(item, index) in options1" :key="index" :label="item.value_1"
                           :value="item.type_id"></el-option>
              </el-select>
              <span style="width: 69px;border: 1px solid #589ff9; margin-left: 5px;" v-if="hasContent"
                    @click="cleanUpEvt">ALL</span>

              <span style="margin-left: 30px;border: 1px solid #589ff9;width:63px" @click="excelEvt"
                    v-if="roles == 6">EXCEL</span>
            </div>

            <div class="over_box" style="width: 100%">
              <div class="btn2">
                <div class="pagination_box">
                  <el-input v-model="paginationInput" style="width: 50px" size="mini" placeholder="To"
                            @change="limitEvt"></el-input>
                  <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1"
                                 :page-size="paginationInput - 0" layout="prev, pager, next, jumper" :total="total"
                                 :pager-count="5">
                  </el-pagination>
                </div>
                <button @click="minxEvt" :class="{ active: activeTab === '1' }"
                        v-if="canView(1)">
                  项目进度
                </button>
                <button @click="min_boxEvt" :class="{ active: activeTab === '2' }"
                        v-if="canView(2)">
                  市场信息
                </button>
                <button @click="min_oneEvt" :class="{ active: activeTab === '3' }"
                        v-if="canView(3)"
                >
                  图量安排
                </button>
                <button @click="min_twoEvt" :class="{ active: activeTab === '4' }"
                        v-if="canView(4)">
                  产值划分
                </button>
                <button @click="min_box_three" :class="{ active: activeTab === '5' }"
                        v-if="canView(5)">
                  成本统计
                </button>
              </div>
              <span class="span_box">{{ total }}</span>
              <el-table @cell-mouse-enter="huaguo" @cell-click="idEvt" show-summary :summary-method="getSummaries"
                        :data="tableData" ref="sortTable" height="55%" style="margin-top: 45px;"
                        @sort-change="sortChangeEvt"
                        border :row-class-name="customRowClass" v-sort-orders="['descending', 'ascending', '']"
                        :empty-text="dataLoaded ? '暂无数据' : '正在加载数据中...'">
                <el-table-column prop="name" label="项目名称" fixed sortable="custom" width="315px" align="left"
                                 :sort-orders="orders">
                  <template slot-scope="props">
                    <span class="white_over" @click="openChildDialog(2)" v-if="activeTab === '3'"
                          :style="{ color: props.row.name_color == '1' ? '#000' : '#f00' }" style="cursor:pointer">
                      {{ props.row.name }}
                    </span>
                    <span class="white_over" @click="openChildDialog(2)" v-else style="cursor:pointer">
                      {{ props.row.name }}
                    </span>
                  </template>
                </el-table-column>
                <template v-if="showNameColumn">
                  <el-table-column prop="status" label="项目进度" width="120" sortable="custom" :sort-orders="orders">
                    <template slot-scope="props">
                      <div style="cursor:pointer">
                        <el-dropdown trigger="click" @command="activeEvt">
                          <span style="width:100px;display:flex;height:22px" @click="activeTextEvt(props.row)"
                                class="el-dropdown-link  white_over" :style="{
                            color: props.row.status == '暂停' ? '#f00' : '#ada7a7'
                          }">
                            {{ props.row.status }} <i class="el-icon-caret-bottom"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :disabled="props.row.status == '进行中'" command="1">进行中
                            </el-dropdown-item>
                            <el-dropdown-item :disabled="props.row.status == '暂停'" command="2">暂停</el-dropdown-item>
                            <el-dropdown-item :disabled="props.row.status == '完工'" command="3">完工</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column prop="progress_remark" label="进度备注" class-name="project_one" width="265"
                                   style="margin-top: 2px;" sortable="custom" :sort-orders="orders">
                    <template slot-scope="scope">
                      <div style="width: 100% ; overflow: auto;">
                        <div style="position: relative;">
                          <el-popover placement="bottom" popper-class="Popover_box" @hide="sevEvt" @show="showEvt"
                                      :ref="`popover-${scope.$index}`" style="max-width: 100%;">
                            <el-collapse :accordion="true" v-model="activeName">
                              <el-collapse-item ref="collapseItem" v-for="(item, index) in popoverData" :key="index"
                                                :name="index.toString()">
                                <template slot="title">
                                  <span
                                      style="font-size:12px;display: flex;margin-bottom: 15px;width:40px;color:#d1d1d1">{{
                                      item.time
                                    }}</span>
                                  <span class="white_over" style="margin-left:30px ;cursor:pointer;width:350px"> {{
                                      item.remark
                                    }}</span>
                                  <i class="el-icon-delete" @click="deleteItem(item , 1)" style="cursor:pointer"></i>
                                </template>
                                <div v-if="ok_Evt">
                                  <el-input :autofocus='true' ref="inputRef" class="input-list"
                                            style="width: 450px;height: 50px;" type="text" v-model="poop"
                                            @keyup.enter.native="cancelEdit(1)"></el-input>
                                </div>
                                <div v-if="!isEditing[index]">{{ item.remark }}</div>
                              </el-collapse-item>
                            </el-collapse>
                            <div style="float: right; margin-right: 10px; margin-top: 10px;">
                              <button @click="handleAdd(1)" style=" cursor:pointer"
                                      v-if="ok_Evt == false ? true : false">新增
                              </button>
                              <button @click="cancelEdit(1)" style=" cursor:pointer"
                                      v-if="ok_Evt == true ? true : false">确定
                              </button>
                              <button @click="closePopover(scope)" style=" cursor:pointer"
                                      v-if="ok_Evt == true ? true : false">取消
                              </button>
                            </div>
                            <div slot="reference">
                              <div class="white_over_one" style="cursor:pointer; display: flex;">
                                <span class="white_over" style="width: 280px !important;">
                                  {{ getProgressRemarkString(scope.row.progress_remark) }}
                                </span>
                                <i class="el-icon-edit" style="float: right;"></i>
                              </div>
                            </div>
                          </el-popover>
                        </div>
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column prop="content_remark" label="制作备注" width="310" class-name="project_one"
                                   sortable="custom" :sort-orders="orders">
                    <template slot-scope="scope">
                      <div style="width: 100% ; overflow: auto;">
                        <div style="position: relative;">
                          <el-popover placement="bottom" popper-class="Popover_box" @hide="sevEvt"
                                      :ref="`popover-${scope.$index}`" style="max-width: 100%;">
                            <el-collapse accordion v-model="activeName">
                              <el-collapse-item ref="collapseItem" v-for="(item, index) in contentData" :key="index"
                                                :name="index.toString()">
                                <template slot="title">
                                  <span
                                      style="font-size:12px;display: flex;margin-bottom: 15px;width:40px;color:#d1d1d1">{{
                                      item.time
                                    }}</span>
                                  <span class="white_over" style="margin-left:30px;cursor:pointer">{{
                                      item.remark
                                    }}</span>
                                  <i class="el-icon-delete" @click="deleteItem(item, 2)" style="cursor:pointer"></i>
                                </template>
                                <div>
                                  <div v-if="!isEditing[index]">{{ item.remark }}</div>
                                  <div v-else>
                                    <el-input autofocus="true" ref="inputElement" class="input-list"
                                              style="width: 450px;height: 50px;" type="text" v-model="poop"
                                              @keyup.enter.native="cancelEdit(2)"></el-input>
                                  </div>
                                </div>
                              </el-collapse-item>
                            </el-collapse>
                            <div style="float: right; margin-right: 10px; margin-top: 10px;">
                              <button @click="handleAdd(2)" style=" cursor:pointer"
                                      v-if="ok_Evt == false ? true : false">新增
                              </button>
                              <button @click="cancelEdit(2)" style=" cursor:pointer"
                                      v-if="ok_Evt == true ? true : false">确定
                              </button>
                              <button @click="closePopover()" style=" cursor:pointer"
                                      v-if="ok_Evt == true ? true : false">取消
                              </button>
                            </div>
                            <div slot="reference">
                              <div class="white_over_one" style="cursor:pointer; display: flex;">
                                <span class="white_over" style="width: 280px !important;display: block;">
                                  {{ getProgressRemarkString(scope.row.content_remark) }}
                                </span>
                                <i class="el-icon-edit" style="float: right;"></i>
                              </div>
                            </div>
                          </el-popover>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="customer" label="客户名称" width="230" sortable="custom" :sort-orders="orders"
                                   v-if="roles !== 4 && roles !== 5 && roles !== 8">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.customer }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="value_1" sortable="custom" :sort-orders="orders" label="客户类型" width="120"
                                   v-if="roles !== 4 && roles !== 8 ">
                  </el-table-column>
                  <el-table-column prop="customer_region" sortable="" :sort-orders="orders" label="客户区域" width="120"
                                   v-if="roles !== 4 && roles !== 8 ">

                  </el-table-column>
                  <el-table-column prop="customer_area" sortable="" :sort-orders="orders" label="客户地点" width="120"
                                   v-if="roles !== 4 && roles !== 8 ">

                  </el-table-column>
                  <el-table-column prop="img_total" label="图" width="100" sortable="custom" :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.img_total }}</span>
                      <span class="white_over" v-if="props.row.img_total == 0 " style="color:#d1d1d1">无</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="charge" label="项目经理" width="100" class-name="project_two" sortable="custom"
                                   :sort-orders="orders" v-if="roles !== 8">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.charge }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="sign" label="市场签单" width="100" class-name="project_two" sortable="custom"
                                   :sort-orders="orders" v-if=" roles !== 5 && roles !== 8">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.sign }}</span>
                    </template>
                  </el-table-column>


                  <el-table-column prop="assistant" label="客户维护" width="100" class-name="project_two"
                                   sortable="custom"
                                   :sort-orders="orders" v-if="roles !== 4 && roles !== 5 && roles !== 8">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.assistant }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="start_time" label="开工时间" width="100" class-name="project_shijian"
                                   sortable="custom" :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.start_time }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="demand_time" label="要求完工" width="100" class-name="project_shijian"
                                   sortable="custom" :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.demand_time }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="end_time" label="实际完工" sortable="custom" class-name="project_shijian"
                                   :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.end_time }}</span>
                    </template>
                  </el-table-column>
                </template>
                <template v-if="showNameColumn_box">
                  <el-table-column prop="customer" label="客户名称" width="230" sortable="custom" :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.customer }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="sign" label="市场签单" width="100" sortable="custom" :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.sign }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                      label="合同情况"
                      width="180"
                      v-if="roles !== 5"
                      class-name="popover_three"
                      sortable="custom"
                      prop="pdf_time"
                      :sort-orders="orders"
                  >
                    <template #default="scope">
                      <el-tooltip
                          placement="right"
                          :open-delay="100"
                          trigger="hover"
                          popper-class="popover_one"
                          style="border-radius:7px;"
                      >
                        <!-- 单元格主体 -->
                        <div
                            @mouseenter="hoverRow = scope.$index"
                            @mouseleave="handleMouseLeave($event)"
                            @dragover.prevent="handleDragOver($event, scope.row, scope.$index)"
                            @drop.prevent="handleDrop($event, scope.row, scope.$index)"
                            style="
                            text-align: left;
                            cursor: pointer;
                            background-color: #fff;
                            position: relative;
                            height: 48px;
                            line-height: 48px;
                            padding-left: 10px;
                          "
                        >
                          <!-- 隐藏的文件输入框 -->
                          <input
                              type="file"
                              accept=".pdf"
                              @change="onFileSelect($event, scope.row, scope.$index)"
                              :ref="'fileInput' + scope.$index"
                              style="display: none;"
                          />
                          <!-- 显示内容：有合同时间显示时间，否则显示“上传合同” -->
                          <span
                              v-if="scope.row.pdf_time"
                              class="hover-under"
                              style="color: #333; cursor: pointer;"
                              @click="viewContract(scope.row)"
                          >
                              {{ scope.row.pdf_time }}
                            </span>

                          <span
                              v-else
                              style="color: #999; cursor: pointer;"
                              class="hover-underline"
                              @click="triggerFileInput(scope.$index)"
                          >
                              上传合同
                            </span>
                        </div>
                      </el-tooltip>
                    </template>
                  </el-table-column>

                  <el-table-column
                      label="结算单情况"
                      width="180"
                      v-if="roles !== 5"
                      class-name="popover_three"
                      sortable="custom"
                      prop="invoice_time"
                      :sort-orders="orders"
                  >
                    <template #default="scope">
                      <el-tooltip
                          placement="right"
                          :open-delay="100"
                          trigger="hover"
                          popper-class="popover_one"
                          style="border-radius:7px;"
                      >
                        <!-- 单元格主体 -->
                        <div
                            @mouseenter="hoverRow = scope.$index"
                            @mouseleave="handleSettlementMouseLeave($event)"
                            @dragover.prevent="handleSettlementDragOver($event, scope.row, scope.$index)"
                            @drop.prevent="handleSettlementDrop($event, scope.row, scope.$index)"
                            style="
                            text-align: left;
                            cursor: pointer;
                            background-color: #fff;
                            position: relative;
                            height: 48px;
                            line-height: 48px;
                            padding-left: 10px;
                          "
                        >
                          <!-- 隐藏的文件输入框 -->
                          <input
                              type="file"
                              accept=".pdf"
                              @change="onSettlementFileSelect($event, scope.row, scope.$index)"
                              :ref="'settlementFileInput' + scope.$index"
                              style="display: none;"
                          />
                          <!-- 显示内容：有结算单时间显示时间，否则显示“上传结算单” -->
                          <span
                              v-if="scope.row.invoice_time"
                              class="hover-under"
                              style="color: #333; cursor: pointer;"
                              @click="viewSettlement(scope.row)"
                          >
                              {{ scope.row.invoice_time }}
                            </span>

                          <span
                              v-else
                              style="color: #999; cursor: pointer;"
                              class="hover-underline"
                              @click="triggerSettlementFileInput(scope.$index)"
                          >
                              上传结算单
                            </span>
                        </div>
                      </el-tooltip>
                    </template>
                  </el-table-column>


                  <el-table-column prop="back_status" label="回款情况" width="100" class-name="project_one"
                                   sortable="custom" :sort-orders="orders">
                  </el-table-column>
                  <el-table-column prop="refund_remark" label="回款备注" width="105" class-name="project_one"
                                   :sort-orders="orders">
                    <template slot-scope="scope">
                      <div style="width: 100% ; overflow: auto;">
                        <div style="position: relative;">
                          <el-popover placement="bottom" popper-class="Popover_box" @hide="sevEvt"
                                      :ref="`popover-${scope.$index}`" style="max-width: 100%;">
                            <el-collapse accordion v-model="activeName">
                              <el-collapse-item ref="collapseItem" v-for="(item, index) in refundData" :key="index"
                                                :name="index.toString()">
                                <template slot="title">
                                  <span
                                      style="font-size:12px;display: flex;margin-bottom: 15px;width:40px;color:#d1d1d1">{{
                                      item.time
                                    }}</span>
                                  <span class="white_over" style="margin-left:30px;cursor:pointer">{{
                                      item.remark
                                    }}</span>
                                  <i class="el-icon-delete" style=" cursor:pointer" @click="deleteItem(item, 3)"></i>
                                </template>
                                <div>
                                  <div v-if="!isEditing[index]">{{ item.remark }}</div>
                                  <div v-else>
                                    <el-input autofocus ref="inputElement" class="input-list"
                                              style="width: 450px;height: 50px;" type="text" v-model="poop"
                                              @keyup.enter.native="cancelEdit(3)"></el-input>
                                  </div>
                                </div>
                              </el-collapse-item>
                            </el-collapse>
                            <div style="float: right; margin-right: 10px; margin-top: 10px;">
                              <button @click="handleAdd(3)" style=" cursor:pointer"
                                      v-if="ok_Evt == false ? true : false">新增
                              </button>
                              <button @click="cancelEdit(3)" style=" cursor:pointer"
                                      v-if="ok_Evt == true ? true : false">确定
                              </button>
                              <button @click="closePopover()" style=" cursor:pointer"
                                      v-if="ok_Evt == true ? true : false">取消
                              </button>
                            </div>
                            <div slot="reference">
                              <div class="white_over_one" style="cursor:pointer; display: flex;">
                                <span class="white_over" style="width: 280px !important;display: block;">
                                  {{ getProgressRemarkString(scope.row.refund_remark) }}
                                </span>
                                <i class="el-icon-edit" style="float: right;"></i>
                              </div>
                            </div>
                          </el-popover>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="converted_amount" label="合同折算" width="110" class-name="project_three"
                                   sortable="custom" :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.converted_amount }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="backed_amount" label="回款折算" width="110" class-name="project_three"
                                   sortable="custom" :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.backed_amount }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="wait_amount" label="未回折算" width="110" class-name="project_three"
                                   sortable="custom" :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.wait_amount }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="unback_day" label="未回周期" width="100" class-name="project_two"
                                   sortable="custom"
                                   :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.unback_day }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="backed_days" label="回款周期" width="100" class-name="project_two"
                                   sortable="custom" :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.backed_days }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="income_time" label="回款时间" width="100" class-name="project_two"
                                   sortable="custom" :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.income_time }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="contract_amount" label="合同金额" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.contract_amount }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="currency" label="货币单位" width="120" sortable="custom" :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.currency }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="assistant" label="客户维护" width="120" sortable="custom"
                                   :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.assistant }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column prop="first_sales" label="客户开发" width="120" sortable="custom"
                                   :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.first_sales }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column prop="start_time" label="开工时间" width="120" class-name="project_shijian"
                                   sortable="custom" :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.start_time }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="end_time" label="实际完工" width="100" class-name="project_shijian"
                                   sortable="custom" :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.end_time }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="customer_type" label="客户类型" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.customer_type }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="theory_amount" label="理论总价" sortable="custom" :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.theory_amount }}</span>
                    </template>
                  </el-table-column>
                </template>
                <template v-if="showNameColumn_box_one">
                  <el-table-column prop="type_plan" label="规划" width="100" class-name="project_one" sortable="custom"
                                   :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.type_plan }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="type_birdview" label="鸟瞰" class-name="project_one" width="105"
                                   sortable="custom" :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.type_birdview }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="type_perspective" label="透视" class-name="project_one" width="110"
                                   sortable="custom" :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.type_perspective }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="type_indoor" label="室内" class-name="project_one" width="110"
                                   sortable="custom"
                                   :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.type_indoor }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="type_vr" label="VR" class-name="project_one" width="110" sortable="custom"
                                   :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.type_vr }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="type_animation" class-name="project_one" label="动画" width="100"
                                   sortable="custom" :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.type_animation }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="demand_time" label="要求完工" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.demand_time }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="progress_remark" label="进度备注" class-name="project_three" width="220"
                                   :sort-orders="orders">
                    <template slot-scope="scope">
                      <div style="width: 100% ; overflow: auto;">
                        <div style="position: relative;">
                          <el-popover placement="bottom" popper-class="Popover_box" @hide="sevEvt"
                                      :ref="`popover-${scope.$index}`" style="max-width: 100%;">
                            <el-collapse accordion v-model="activeName">
                              <el-collapse-item ref="collapseItem" v-for="(item, index) in popoverData" :key="index"
                                                :name="index.toString()">
                                <template slot="title">
                                  <span
                                      style="font-size:12px;display: flex;margin-bottom: 15px;width:40px;color:#d1d1d1">{{
                                      item.time
                                    }}</span>
                                  <span class="white_over" style="margin-left:30px;cursor:pointer">{{
                                      item.remark
                                    }}</span>
                                  <i class="el-icon-delete" style="cursor:pointer" @click="deleteItem(item, 1)"></i>
                                </template>
                                <div>
                                  <div v-if="!isEditing[index]">{{ item.remark }}</div>
                                  <div v-else>
                                    <el-input autofocus="true" ref="inputElement" class="input-list"
                                              style="width: 450px;height: 50px;" type="text" v-model="poop"
                                              @keyup.enter.native="cancelEdit(1)"></el-input>
                                  </div>
                                </div>
                              </el-collapse-item>
                            </el-collapse>
                            <div style="float: right; margin-right: 10px; margin-top: 10px;">
                              <button @click="handleAdd(1)" style=" cursor:pointer"
                                      v-if="ok_Evt == false ? true : false">新增
                              </button>
                              <button @click="cancelEdit(1)" style=" cursor:pointer"
                                      v-if="ok_Evt == true ? true : false">确定
                              </button>
                              <button @click="closePopover(scope)" style=" cursor:pointer"
                                      v-if="ok_Evt == true ? true : false">取消
                              </button>
                            </div>
                            <div slot="reference">
                              <div class="white_over_one" style="cursor:pointer; display: flex;">
                                <span class="white_over" style="width: 280px !important;display: block;">
                                  {{ getProgressRemarkString(scope.row.progress_remark) }}
                                </span>
                                <i class="el-icon-edit" style="float: right;"></i>
                              </div>
                            </div>
                          </el-popover>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="content_remark" label="内容备注" width="220" class-name="project_three"
                                   :sort-orders="orders">
                    <template slot-scope="scope">
                      <div style="width: 100% ; overflow: auto;">
                        <div style="position: relative;">
                          <el-popover placement="bottom" popper-class="Popover_box" @hide="sevEvt"
                                      :ref="`popover-${scope.$index}`" style="max-width: 100%;">
                            <el-collapse accordion v-model="activeName">
                              <el-collapse-item ref="collapseItem" v-for="(item, index) in contentData" :key="index"
                                                :name="index.toString()" :collapse="true">
                                <template slot="title">
                                  <span
                                      style="font-size:12px;display: flex;margin-bottom: 15px;width:40px;color:#d1d1d1">{{
                                      item.time
                                    }}</span>
                                  <span class="white_over" style="margin-left:30px;cursor:pointer">{{
                                      item.remark
                                    }}</span>
                                  <i class="el-icon-delete" style="cursor:pointer" @click="deleteItem(item, 2)"></i>
                                </template>
                                <div>
                                  <div v-if="!isEditing[index]">{{ item.remark }}</div>
                                  <div v-else>
                                    <el-input autofocus="true" ref="inputElement" class="input-list"
                                              style="width: 450px;height: 50px;" type="text" v-model="poop"
                                              @keyup.enter.native="cancelEdit(2)"></el-input>
                                  </div>
                                </div>
                              </el-collapse-item>
                            </el-collapse>
                            <div style="float: right; margin-right: 10px; margin-top: 10px;">
                              <button @click="handleAdd(2)" style=" cursor:pointer"
                                      v-if="ok_Evt == false ? true : false">新增
                              </button>
                              <button @click="cancelEdit(2)" style=" cursor:pointer"
                                      v-if="ok_Evt == true ? true : false">确定
                              </button>
                              <button @click="closePopover()" style=" cursor:pointer"
                                      v-if="ok_Evt == true ? true : false">取消
                              </button>
                            </div>
                            <div slot="reference">
                              <div class="white_over_one" style="cursor:pointer; display: flex;">
                                <span class="white_over" style="width: 280px !important;display: block;">
                                  {{ getProgressRemarkString(scope.row.content_remark) }}
                                </span>
                                <i class="el-icon-edit" style="float: right;"></i>
                              </div>
                            </div>
                          </el-popover>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="customer" label="客户名称" width="100" sortable="custom" :sort-orders="orders"
                                   v-if="roles !== 4 && roles !== 5 && roles !== 8">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.customer }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="sign" label="市场签单" width="100" sortable="custom" :sort-orders="orders"
                                   v-if="roles !== 5 && roles !== 8">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.sign }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="start_time" label="开工时间" width="120" class-name="project_shijian"
                                   sortable="custom" :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.start_time }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="end_time" label="实际完工" sortable="custom" class-name="project_shijian"
                                   :sort-orders="orders">
                    <template slot-scope="props">
                      <span class="white_over">{{ props.row.end_time }}</span>
                    </template>
                  </el-table-column>
                </template>

                <template v-if="showNameColumn_box_two">
                  <el-table-column prop="yproduction" label="1组-杨长伟" width="120" class-name="project_ect"
                                   sortable="custom"
                                   :sort-orders="orders"
                                   v-if="roles !== 8">

                  </el-table-column>
                  <el-table-column prop="zproduction" label="2组-胡适堡" width="120" class-name="project_ect"
                                   sortable="custom"
                                   :sort-orders="orders"
                                   v-if="roles !== 8"
                  >
                  </el-table-column>
                  <el-table-column prop="cproduction" label="3组-陈章" width="120" class-name="project_ect"
                                   sortable="custom"
                                   :sort-orders="orders"
                                   v-if="roles !== 8"
                  >
                  </el-table-column>
                  <el-table-column prop="four_production" label="4组-程尉东" width="120" class-name="project_ect"
                                   sortable="custom"
                                   :sort-orders="orders"
                                   v-if="roles !== 8"
                  >
                  </el-table-column>
                  <el-table-column prop="five_production" label="5组" width="120" class-name="project_ect"
                                   sortable="custom"
                                   :sort-orders="orders"
                                   v-if="roles !== 8"
                  >
                  </el-table-column>


                  <el-table-column prop="type_plan" label="规划" width="82" class-name="project_one" sortable="custom"
                                   :sort-orders="orders">
                  </el-table-column>
                  <el-table-column prop="type_birdview" label="鸟瞰" width="100" class-name="project_one"
                                   sortable="custom" :sort-orders="orders">
                  </el-table-column>
                  <el-table-column prop="type_perspective" label="透视" width="100" class-name="project_one"
                                   sortable="custom" :sort-orders="orders">
                  </el-table-column>
                  <el-table-column prop="type_indoor" label="室内" width="100" class-name="project_one"
                                   sortable="custom"
                                   :sort-orders="orders">
                  </el-table-column>
                  <el-table-column prop="type_vr" label="VR" width="100" class-name="project_one" sortable="custom"
                                   :sort-orders="orders">
                  </el-table-column>
                  <el-table-column prop="type_animation" label="动画" class-name="project_one" width="100"
                                   sortable="custom" :sort-orders="orders">
                  </el-table-column>


                  <el-table-column v-if="fieldShow('yproduction') " prop="yproduction" label="1组-杨长伟"
                                   class-name="project_three" width="120" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'实际产值'" placement="top">
                        <span>1组-杨长伟</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>

                  <el-table-column v-if="fieldShow('zproduction')" prop="zproduction" label="2组-胡适堡"
                                   class-name="project_three" width="120" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'实际产值'" placement="top">
                        <span>2组-胡适堡</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="fieldShow('cproduction') " prop="cproduction" label="3组-陈章"
                                   class-name="project_three" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'实际产值'" placement="top">
                        <span>3组-陈章</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="four_production" label="4组-程尉东" class-name="project_three" width="120"
                                   v-if="fieldShow('four_production') " sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'实际产值'" placement="top">
                        <span>4组-程尉东</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="five_production" label="5组" class-name="project_three" width="100"
                                   v-if="fieldShow('five_production') " sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'实际产值'" placement="top">
                        <span>5组</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="fieldShow('y_back') " prop="y_back" label="1组-杨长伟" width="120"
                                   sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'实际回款'" placement="top">
                        <span>一组-杨长伟</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="fieldShow('z_back') " prop="z_back" label="2组-胡适堡" width="120"
                                   sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'实际回款'" placement="top">
                        <span>2组-胡适堡</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="fieldShow('c_back') " prop="c_back" label="3组-陈章" width="100"
                                   sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'实际回款'" placement="top">
                        <span>3组-陈章</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="fieldShow('four_back') " prop="four_back" label="4组-程尉东" width="120"
                                   sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'实际回款'" placement="top">
                        <span>4组-程尉东</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="fieldShow('five_back') " prop="five_back" label="5组" width="100"
                                   sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'实际回款'" placement="top">
                        <span>5组</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>

                  <el-table-column prop="yratio" label="1组-杨长伟" width="120" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'产值比例'" placement="top">
                        <span>1组-杨长伟</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="zratio" label="2组-胡适堡" width="120" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'产值比例'" placement="top">
                        <span>2组-胡适堡</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="cratio" label="3组-陈章" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'产值比例'" placement="top">
                        <span>3组-陈章</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="four_ratio" label="4组-程尉东" width="120" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'产值比例'" placement="top">
                        <span>4组-程尉东</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="five_ratio" label="5组" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'产值比例'" placement="top">
                        <span>5组</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ytype_plan" label="规划" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'杨长伟'" placement="top">
                        <span>规划</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ytype_birdview" label="鸟瞰" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'杨长伟'" placement="top">
                        <span>鸟瞰</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ytype_perspective" label="透视" width="80" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'杨长伟'" placement="top">
                        <span>透视</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ytype_indoor" label="室内" width="80" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'杨长伟'" placement="top">
                        <span>室内</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ytype_vr" label="VR" width="80" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'杨长伟'" placement="top">
                        <span>VR</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ytype_animation" label="动画" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'杨长伟'" placement="top">
                        <span>动画</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ztype_plan" label="规划" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'胡适堡'" placement="top">
                        <span>规划</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ztype_birdview" label="鸟瞰" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'胡适堡'" placement="top">
                        <span>鸟瞰</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ztype_perspective" label="透视" width="120" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'胡适堡'" placement="top">
                        <span>透视</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ztype_indoor" label="室内" width="120" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'胡适堡'" placement="top">
                        <span>室内</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ztype_vr" label="VR" width="120" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'胡适堡'" placement="top">
                        <span>VR</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ztype_animation" label="动画" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'胡适堡'" placement="top">
                        <span>动画</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ctype_plan" label="规划" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'陈章'" placement="top">
                        <span>规划</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ctype_birdview" label="鸟瞰" width="82" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'陈章'" placement="top">
                        <span>鸟瞰</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ctype_perspective" label="透视" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'陈章'" placement="top">
                        <span>透视</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ctype_indoor" label="室内" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'陈章'" placement="top">
                        <span>室内</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ctype_vr" label="VR" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'陈章'" placement="top">
                        <span>VR</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ctype_animation" label="动画" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'陈章'" placement="top">
                        <span>动画</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="four_type_plan" label="规划" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'程卫东'" placement="top">
                        <span>规划</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="four_birdview" label="鸟瞰" width="82" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'程卫东'" placement="top">
                        <span>鸟瞰</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="four_perspective" label="透视" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'程卫东'" placement="top">
                        <span>透视</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="four_indoor" label="室内" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'程卫东'" placement="top">
                        <span>室内</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="four_vr" label="VR" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'程卫东'" placement="top">
                        <span>VR</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="four_animation" label="动画" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'程卫东'" placement="top">
                        <span>动画</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="five_type_plan" label="规划" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'五组'" placement="top">
                        <span>规划</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="five_birdview" label="鸟瞰" width="82" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'五组'" placement="top">
                        <span>鸟瞰</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="five_perspective" label="透视" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'五组'" placement="top">
                        <span>透视</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="five_indoor" label="室内" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'五组'" placement="top">
                        <span>室内</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="five_vr" label="VR" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'五组'" placement="top">
                        <span>VR</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="five_animation" label="动画" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'五组'" placement="top">
                        <span>动画</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>

                </template>

                <template v-if="showNameColumn_box_three ">
                  <el-table-column prop="model_rate" label="模型比例" width="82" class-name="lie_one" sortable="custom"
                                   :sort-orders="orders">
                  </el-table-column>
                  <el-table-column prop="render_rate" label="渲染比例" width="100" class-name="lie_one"
                                   sortable="custom"
                                   :sort-orders="orders">
                  </el-table-column>
                  <el-table-column prop="assistant_rate" label="助理比例" width="100" class-name="lie_one"
                                   sortable="custom"
                                   :sort-orders="orders">
                  </el-table-column>
                  <el-table-column prop="total_rate" label="总比例" width="100" class-name="lie_one" sortable="custom"
                                   :sort-orders="orders">
                  </el-table-column>
                  <el-table-column prop="model_cost" label="模型金额" width="82" class-name="lie_two" sortable="custom"
                                   :sort-orders="orders">
                  </el-table-column>
                  <el-table-column prop="render_cost" label="渲染金额" width="100" class-name="lie_two"
                                   sortable="custom"
                                   :sort-orders="orders">
                  </el-table-column>
                  <el-table-column prop="assistant_cost" label="助理金额" width="100" class-name="lie_two"
                                   sortable="custom"
                                   :sort-orders="orders">
                  </el-table-column>
                  <el-table-column prop="total_cost" label="总金额" width="100" class-name="lie_two" sortable="custom"
                                   :sort-orders="orders">
                  </el-table-column>
                  <el-table-column prop="converted_amount" label="折算金额" width="100" class-name="lie_two"
                                   sortable="custom" :sort-orders="orders">
                  </el-table-column>
                  <el-table-column prop="type_plan" label="规划" width="82" class-name="lie_three" sortable="custom"
                                   :sort-orders="orders">
                  </el-table-column>
                  <el-table-column prop="type_birdview" label="鸟瞰" width="100" class-name="lie_three"
                                   sortable="custom"
                                   :sort-orders="orders">
                  </el-table-column>
                  <el-table-column prop="type_perspective" label="透视" width="100" class-name="lie_three"
                                   sortable="custom" :sort-orders="orders">
                  </el-table-column>
                  <el-table-column prop="type_indoor" label="室内" width="100" class-name="lie_three" sortable="custom"
                                   :sort-orders="orders">
                  </el-table-column>
                  <el-table-column prop="type_vr" label="VR" width="100" class-name="lie_three" sortable="custom"
                                   :sort-orders="orders">
                  </el-table-column>
                  <el-table-column prop="type_animation" label="动画" width="100" class-name="lie_three"
                                   sortable="custom"
                                   :sort-orders="orders">
                  </el-table-column>
                  <el-table-column prop="yproduction" label="1组-杨长伟" width="120" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'实际产值'" placement="top">
                        <span>1组-杨长伟</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="zproduction" label="2组-胡适堡" width="120" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'实际产值'" placement="top">
                        <span>2组-胡适堡</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="cproduction" label="3组-陈章" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'实际产值'" placement="top">
                        <span>3组-陈章</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="four_production" label="4组-程尉东" width="120" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'实际产值'" placement="top">
                        <span>4组-程尉东</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="five_production" label="5组" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'实际产值'" placement="top">
                        <span>5组</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="y_back" label="1组-杨长伟" width="120" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'实际回款'" placement="top">
                        <span>一组-杨长伟</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="z_back" label="2组-胡适堡" width="120" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'实际回款'" placement="top">
                        <span>2组-胡适堡</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="c_back" label="3组-陈章" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'实际回款'" placement="top">
                        <span>3组-陈章</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="four_back" label="4组-程尉东" width="120" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'实际回款'" placement="top">
                        <span>4组-程尉东</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="five_back" label="5组" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'实际回款'" placement="top">
                        <span>5组</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="yratio" label="1组-杨长伟" width="120" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'产值比例'" placement="top">
                        <span>1组-杨长伟</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="zratio" label="2组-胡适堡" width="120" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'产值比例'" placement="top">
                        <span>2组-胡适堡</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="cratio" label="3组-陈章" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'产值比例'" placement="top">
                        <span>3组-陈章</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="four_ratio" label="4组-程尉东" width="120" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'产值比例'" placement="top">
                        <span>4组-程尉东</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="five_ratio" label="5组" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'产值比例'" placement="top">
                        <span>5组</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ytype_plan" label="规划" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'杨长伟'" placement="top">
                        <span>规划</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ytype_birdview" label="鸟瞰" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'杨长伟'" placement="top">
                        <span>鸟瞰</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ytype_perspective" label="透视" width="80" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'杨长伟'" placement="top">
                        <span>透视</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ytype_indoor" label="室内" width="80" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'杨长伟'" placement="top">
                        <span>室内</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ytype_vr" label="VR" width="80" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'杨长伟'" placement="top">
                        <span>VR</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ytype_animation" label="动画" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'杨长伟'" placement="top">
                        <span>动画</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ztype_plan" label="规划" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'胡适堡'" placement="top">
                        <span>规划</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ztype_birdview" label="鸟瞰" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'胡适堡'" placement="top">
                        <span>鸟瞰</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ztype_perspective" label="透视" width="120" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'胡适堡'" placement="top">
                        <span>透视</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ztype_indoor" label="室内" width="120" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'胡适堡'" placement="top">
                        <span>室内</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ztype_vr" label="VR" width="120" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'胡适堡'" placement="top">
                        <span>VR</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ztype_animation" label="动画" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'胡适堡'" placement="top">
                        <span>动画</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ctype_plan" label="规划" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'陈章'" placement="top">
                        <span>规划</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ctype_birdview" label="鸟瞰" width="82" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'陈章'" placement="top">
                        <span>鸟瞰</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ctype_perspective" label="透视" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'陈章'" placement="top">
                        <span>透视</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ctype_indoor" label="室内" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'陈章'" placement="top">
                        <span>室内</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ctype_vr" label="VR" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'陈章'" placement="top">
                        <span>VR</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ctype_animation" label="动画" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'陈章'" placement="top">
                        <span>动画</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="four_type_plan" label="规划" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'程卫东'" placement="top">
                        <span>规划</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="four_birdview" label="鸟瞰" width="82" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'程卫东'" placement="top">
                        <span>鸟瞰</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="four_perspective" label="透视" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'程卫东'" placement="top">
                        <span>透视</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="four_indoor" label="室内" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'程卫东'" placement="top">
                        <span>室内</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="four_vr" label="VR" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'程卫东'" placement="top">
                        <span>VR</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="four_animation" label="动画" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'程卫东'" placement="top">
                        <span>动画</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="five_type_plan" label="规划" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'五组'" placement="top">
                        <span>规划</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="five_birdview" label="鸟瞰" width="82" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'五组'" placement="top">
                        <span>鸟瞰</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="five_perspective" label="透视" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'五组'" placement="top">
                        <span>透视</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="five_indoor" label="室内" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'五组'" placement="top">
                        <span>室内</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="five_vr" label="VR" width="100" sortable="custom" :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'五组'" placement="top">
                        <span>VR</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="five_animation" label="动画" width="100" sortable="custom"
                                   :sort-orders="orders">
                    <template slot="header">
                      <el-tooltip effect="dark" :content="'五组'" placement="top">
                        <span>动画</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </el-main>
      </el-container>
      <el-dialog :visible.sync="dialogVisible" width="1400" custom-class="sousuo">
        <div style="height:360px;">
          <span
              style="width: 69px;border: 1px solid #589ff9;height: 26px;font-size: 12px;line-height: 26px;color: #589ff9;border-radius: 3px;cursor: pointer;display: flex;justify-content: center;margin: 0 40px 30px;"
              @click="cleanUpEvt">ALL</span>
          <div style="height:300px;display:flex">
            <!-- 搜索栏 -->
            <div>
              <div style="margin-top: 10px;margin-left: 30px;">
                <span>项目名称</span>
                <el-input v-model="name" @change="getList" :class="{ 'vip': name && name.length != '0' }" clearable
                          @click="disabled = !disabled" style="width: 180px;height: 40px;">
                </el-input>
              </div>
              <div style="margin-top: 10px;margin-left: 30px;">
                <span>项目进度</span>
                <el-cascader @change="status_box" v-model="status" :options="options2" filterable clearable
                             :class="{ 'vip': status && status !== '项目进度' }" style="width: 180px;height: 40px;">
                </el-cascader>
              </div>

              <div style="margin-top: 10px;margin-left: 30px;"
                   v-if="(roles == 5 || roles === 8) ? false:true"
              >
                <span>回款情况</span>
                <el-select v-model="back_status" style="width: 180px;height: 40px;" multiple
                           v-if="roles == 5 ? false : true " @change="handleSelectionChange" collapse-tags>
                  <el-option clearable v-for="item in options3" :key="item.value" :label="item.label"
                             :value="item.value"
                             :class="{ 'vip': back_status && back_status !== '回款情况' }"></el-option>
                </el-select>
              </div>

              <div style="margin-top: 10px;margin-left: 30px;" v-if="roles == 3 || roles == 6">
                <span>合同管理</span>
                <el-select v-model="pdf" style="width: 180px;height: 40px;" clearable :class="{ 'vip': pdf }"
                           v-if="roles == 5 ? false : true " @change="pdfChange">
                  <el-option clearable v-for="item in options4" :key="item.value" :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </div>
              <div style="margin-top: 10px;margin-left: 30px;" v-if="roles == 3 || roles == 6">
                <span>结算单</span>
                <el-select v-model="invoice" style="width: 180px;height: 40px;" clearable :class="{ 'vip': invoice }"
                           v-if="roles == 5 ? false : true " @change="invoiceChange">
                  <el-option clearable v-for="item in options5" :key="item.value" :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </div>
            </div>

            <div>
              <div style="margin-top: 10px;margin-left: 30px;"
                   v-if="(roles == 5 || roles === 8)?false:true"
              >
                <span>客户名称</span>
                <el-input v-model="customer" @change="getList" v-if="roles == 5 ? false : true"
                          :class="{ 'vip': customer && customer.length != '0' }" clearable
                          style="width: 180px;height: 40px;">
                </el-input>
              </div>
              <div style="margin-top: 10px;margin-left: 30px;"
                   v-if="(roles == 5 || roles === 8)?false:true"
              >
                <span> 客户区域</span>
                <el-cascader @change="customer_box" v-model="region" popper-class='custom_box'
                             v-if="roles == 5 ? false : true" :options="options" filterable clearable
                             :class="{ 'vip': region && region !== '客户区域' }" style="width: 180px;height: 40px;">
                </el-cascader>
              </div>
              <div style="margin-top: 10px;margin-left: 30px;"
                   v-if="(roles == 5 || roles === 8)?false:true"
              >
                <span>客户类型</span>
                <el-select v-if="roles == 5 ? false : true" v-model="type_id" filterable @change="Customer_type"
                           clearable
                           :class="{ 'vip': type_id && type_id !== '客户类型' }"
                           style="width: 180px;height: 40px;">
                  <el-option v-for="(item, index) in options1" :key="index" :label="item.value_1"
                             :value="item.type_id"></el-option>
                </el-select>
              </div>
              <div style="margin-top: 10px;margin-left: 30px;"
                   v-if="(roles == 5 || roles === 8)?false:true"
              >
                <span>客户地点</span>
                <el-input v-model="customer_area" @change="getList" v-if="roles == 5 ? false : true"
                          :class="{ 'vip': customer_area && customer_area.length != '0' }" clearable
                          style="width: 180px;height: 40px;">
                </el-input>
              </div>
            </div>
            <div v-if="(roles == 5 || roles === 8)?false:true">
              <div style="margin-top: 10px;margin-left: 30px;">
                <span>签单人</span>
                <el-select v-model="sign" filterable @change="signChange" v-if="roles == 5 ? false : true" clearable
                           :class="{ 'vip': sign && sign !== '签单人' }" style="width: 180px;height: 40px;">
                  <el-option v-for="(item, index) in set_of" :key="index" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div style="margin-top: 10px;margin-left: 30px;">
                <span> 维护人</span>
                <el-select v-model="assistant" filterable @change="assistantChange" style="width: 180px;height: 40px;"
                           v-if="roles == 5 ? false : true" clearable
                           :class="{ 'vip': assistant && assistant !== '维护人' }">
                  <el-option v-for="(item, index) in assistant_id" :key="index" :label="item.name"
                             :value="item.id"></el-option>
                </el-select>
              </div>
              <div style="margin-top: 10px;margin-left: 30px;">
                <span> 开发人</span>
                <el-select v-model="first_sales" filterable @change="first_salesChange"
                           style="width: 180px;height: 40px;"
                           v-if="roles == 5 ? false : true" clearable
                           :class="{ 'vip': first_sales && first_sales !== '客户开发' }">
                  <el-option v-for="(item, index) in first_sales_id" :key="index" :label="item.name"
                             :value="item.id"></el-option>
                </el-select>
              </div>


              <div style="margin-top: 10px;margin-left: 30px;">
                <span>翻译 </span>
                <el-select v-model="charge_id" filterable @change="charge_idChange" clearable
                           :class="{ 'vip': charge_id && charge_id !== '翻译' }"
                           style="margin-left: 13px;width: 180px;height: 40px;">
                  <el-option v-for="(item, index) in charge" :key="index" :label="item.name"
                             :value="item.id"></el-option>
                </el-select>
              </div>
              <div style="margin-top: 10px;margin-left: 30px;">
                <span>小组</span>
                <el-select v-model="group_one" filterable @change="groupChange" clearable
                           :class="{ 'vip': group_one && group_one !== '小组' }"
                           style="margin-left: 13px;width: 180px;height: 40px;">
                  <el-option v-for="(item, index) in group" :key="index" :label="item.name"
                             :value="item.id"></el-option>
                </el-select>
              </div>
            </div>
            <div>
              <div style="margin-top: 10px;margin-left: 30px;">
                <span>进度备注</span>
                <el-input v-model="progress_remark" @change="getList" clearable
                          :class="{ 'vip': progress_remark && progress_remark.length != '0' }"
                          style="width: 180px;height: 40px;">
                </el-input>
              </div>
              <div style="margin-top: 10px;margin-left: 30px;">
                <span>制作备注</span>
                <el-input v-model="content_remark" @change="getList" clearable
                          :class="{ 'vip': content_remark && content_remark.length != '0' }"
                          style="width: 180px;height: 40px;">
                </el-input>
              </div>
              <div style="margin-top: 10px;margin-left: 30px;"
                   v-if="(roles == 5 || roles === 8)?false:true"
              >
                <span>回款备注</span>
                <el-input v-model="refund_remark" @change="getList" clearable style="width: 180px;height: 40px;"
                          v-if="roles == 5 ? false : true "
                          :class="{ 'vip': refund_remark && refund_remark.length != '0' }">
                </el-input>
              </div>
            </div>
            <div>
              <div style="margin-top: 10px;margin-left: 30px;">
                <span>开工时间</span>
                <el-popover placement="top" width="350" v-model="visible">
                  <Tanchu @handle-click="getTimestamp('1', $event)"/>
                  <div style="display:flex;justify-content: space-evenly;padding: 10px 0 10px;">

                    <el-date-picker v-model="value3_1" type="date" placeholder="之前"></el-date-picker>

                    <el-date-picker v-model="value3" type="date" placeholder="之后"></el-date-picker>
                  </div>
                  <hr style="border-color: #fff;"/>
                  <div style="text-align: right; margin: 0;margin-right:15px;margin-top:20px">
                    <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                    <el-button type="primary" size="mini" @click="queren_E">确定</el-button>
                  </div>
                  <el-input slot="reference" :class="{ 'dynamic-background': isDynamicBackground }"
                            :placeholder="value3_1 || value3 ? (value3_1 ? formatDate(value3_1) : '') + (value3 ? ('--' + formatDate(value3)) : '') : (startDate0 && endDate0 ? startDate0 + '--' + endDate0 : '开工时间')"
                            style="width: 180px;height: 40px;">
                    <template slot="suffix">
                      <i class="el-input__icon el-icon-circle-close" @click="clearInput(1)"></i>
                    </template>
                  </el-input>
                </el-popover>

              </div>
              <div style="margin-top: 10px;margin-left: 30px;">
                <span>要求完工</span>
                <el-popover placement="top" width="350" v-model="visible_1" style="width: 180px;height: 40px;">
                  <Tanchu @handle-click="getTimestamp('2', $event)"/>
                  <div style="display:flex;justify-content: space-evenly;padding: 10px 0 10px;">
                    <el-date-picker v-model="value2_1" type="date" placeholder="之前"></el-date-picker>
                    <el-date-picker v-model="value2" type="date" placeholder="之后"></el-date-picker>
                  </div>
                  <hr style="border-color: #fff;"/>
                  <div style="text-align: right; margin: 0;margin-right:15px;margin-top:20px">
                    <el-button size="mini" type="text" @click="visible_1 = false">取消</el-button>
                    <el-button type="primary" size="mini" @click="queren_Ev">确定</el-button>
                  </div>
                  <el-input slot="reference" :class="{ 'dynamic-background': isDynamicBackground1 }"
                            :placeholder="value2_1 || value2 ? (value2_1 ? formatDate(value2_1) : '') + (value2 ? ('--' + formatDate(value2)) : '') : (startDate1 && endDate1 ? startDate1 + '--' + endDate1 : '要求完工')"
                            style="width: 180px;height: 40px;">
                    <template slot="suffix">
                      <i class="el-input__icon el-icon-circle-close" @click="clearInput(2)"></i>
                    </template>
                  </el-input>
                </el-popover>
              </div>
              <div style="margin-top: 10px;margin-left: 30px;">
                <span>实际完工</span>
                <el-popover placement="top" width="350" v-model="visible_2" style="width: 180px;height: 40px;">
                  <Tanchu @handle-click="getTimestamp('3', $event)"/>
                  <div style="display:flex;justify-content: space-evenly;padding: 10px 0 10px;">
                    <el-date-picker v-model="value1_1" type="date" placeholder="之前"></el-date-picker>
                    <el-date-picker v-model="value1" type="date" placeholder="之后"></el-date-picker>
                  </div>
                  <hr style="border-color: #fff;"/>
                  <div style="text-align: right; margin: 0;margin-right:15px;margin-top:20px">
                    <el-button size="mini" type="text" @click="visible_2 = false">取消</el-button>
                    <el-button type="primary" size="mini" @click="queren_Evt">确定</el-button>
                  </div>
                  <el-input slot="reference" :class="{ 'dynamic-background': isDynamicBackground2 }"
                            :placeholder="value1_1 || value1 ? (value1_1 ? formatDate(value1_1) : '') + (value1 ? ('--' + formatDate(value1)) : '') : (startDate2 && endDate2 ? startDate2 + '--' + endDate2 : '实际完工')"
                            style="width: 180px;height: 40px;">
                    <template slot="suffix">
                      <i class="el-input__icon el-icon-circle-close" @click="clearInput(3)"></i>
                    </template>
                  </el-input>
                </el-popover>
              </div>
              <div style="margin-top: 10px;margin-left: 30px;">
                <span>回款时间</span>
                <el-popover placement="top" width="350" v-model="visible_3" style="width: 180px;height: 40px;">
                  <Tanchu @handle-click="getTimestamp('4', $event)"/>
                  <div style="display:flex;justify-content: space-evenly;padding: 10px 0 10px;">
                    <el-date-picker v-model="value0_1" type="date" placeholder="之前"></el-date-picker>
                    <el-date-picker v-model="value0" type="date" placeholder="之后"></el-date-picker>
                  </div>
                  <hr style="border-color: #fff;"/>

                  <div style="text-align: right; margin: 0;margin-right:15px;margin-top:20px">
                    <el-button size="mini" type="text" @click="visible_3 = false">取消</el-button>
                    <el-button type="primary" size="mini" @click="queren_Evte">确定</el-button>
                  </div>
                  <el-input slot="reference" :class="{ 'dynamic-background': isDynamicBackground3 }"
                            v-if="roles == 5 ? false : true" style="width: 180px;height: 40px;"
                            :placeholder="value0_1 || value0 ? (value0_1 ? formatDate(value0_1) : '') + (value0 ? ('--' + formatDate(value0)) : '') : (startDate3 && endDate3 ? startDate3 + '--' + endDate3 : '回款时间')">
                    <template
                        slot="suffix">
                      <i class="el-input__icon el-icon-circle-close" @click="clearInput(4)"></i>
                    </template>
                  </el-input>
                </el-popover>
              </div>
            </div>
          </div>
        </div>

      </el-dialog>
      <pop_up ref="childComponentRef" @save-success="handleSaveSuccess"/>

      <Details ref="detailsComponentRef"/>
    </div>
  </div>
</template>

<script>
import GlobalHeader from '@/components/GlobalHeader.vue';
import Tanchu from '@/components/tanchu.vue';
// import List from "@/components/list.vue";
// import List_two from "@/components/list_two.vue";
import pop_up from "@/components/pop_up.vue";
import Details from "@/components/details.vue";
import {
  AddApi,
  DelremarkApi,
  DropdownApi,
  ERPListApi,
  InfoApi,
  ScheduleApi,
  SearchApi,
  StatusApi,
  UploadContractApi,
  UploadctApi
} from "../api/home/home.js";

const delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
export default {
  components: {
    // List,
    // List_two,
    pop_up,
    GlobalHeader,
    Details,
    Tanchu
  },

  data() {
    return {

      activeIndex: "1",
      tableData: [],
      total: null,
      paginationInput: 95,
      currentPage1: 1,
      sign: null,
      status: null,
      customer: null,
      customer_area: null,
      end_time: null,
      demand_time: null,
      assistant: null,
      first_sales: null,
      name: null,
      group_id: null,
      group: null,
      group_one: null,
      charge_id: null,
      charge: null,
      assistant_id: null,
      first_sales_id: null,
      back_status: [],
      progress_remark: null,
      content_remark: null,
      refund_remark: null,
      pdf: '',
      sign_id: null,
      type_id: null,
      region: null,
      input1: null,
      isPopupOpen: false,
      activeName: [],
      activeName_box: '0',
      totalRow: null,
      data: {},
      //排序
      order: null,
      orField: null,

      set_of: null,
      schedule: null,
      options1: [],

      options: [{
        value: '2',
        label: '中东',
      }, {
        value: '3',
        label: '东南亚',
      }, {
        value: '4',
        label: '国内沿海',
      }, {
        value: '5',
        label: '内地',
      }, {
        value: '6',
        label: '北美',
      }, {
        value: '7',
        label: '南美',
      }, {
        value: '8',
        label: '欧洲',
      }, {
        value: '9',
        label: '澳洲',
      }, {
        value: '10',
        label: '其他',
      }],
      options2: [{
        value: '1',
        label: '进行中',
      }, {
        value: '2',
        label: '暂停',
      }, {
        value: '3',
        label: '完工',
      }],
      options3: [{
        value: '1',
        label: '未回',
      }, {
        value: '2',
        label: '部分回款',
      }, {
        value: '3',
        label: '已回款',
      }],

      options4: [{
        value: '2',
        label: '有合同',
      }, {
        value: '1',
        label: '无合同',
      }],
      options5: [{
        value: '1',
        label: '无',
      }, {
        value: '2',
        label: '有',
      }],
      invoice: null,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const current = new Date();
              let nowDayOfWeek = current.getDay();
              if (nowDayOfWeek === 0) nowDayOfWeek = 7;
              const dayNum = 1 * 24 * 60 * 60 * 1000;
              const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
              const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "当月",
            onClick(picker) {
              const date = new Date();
              const year = date.getFullYear();
              const month = date.getMonth();
              let thisMonthStartDate = new Date(year, month, 1);
              let thisMonthEndDate = new Date(year, month + 1, 0);
              picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
            },
          },
          {
            text: "当年",
            onClick(picker) {
              var tYear = new Date().getFullYear();
              var startTime = new Date(tYear, 0, 1); //当前年第一天
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, start]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              const current = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
              let nowDayOfWeek = current.getDay();
              let diffToMonday =
                  current.getDate() - nowDayOfWeek + (nowDayOfWeek === 0 ? -6 : 1);
              const firstDate = new Date(current.setDate(diffToMonday));
              const lastDate = new Date(current.setDate(diffToMonday + 6));
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              var now = new Date();
              var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
              var ed = new Date(now.getFullYear(), now.getMonth(), 0);
              picker.$emit("pick", [fd, ed]);
            },
          },
          {
            text: "去年",
            onClick(picker) {
              var tYear = new Date().getFullYear() - 1;
              var startTime = new Date(tYear, 0, 1);
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
        ],
      },
      value1: "",
      value1_1: '',
      value2: "",
      value2_1: '',
      value3: '',
      value3_1: '',

      value0: '',
      value0_1: '',


      isValue3Empty_1: true,
      isValue3Empty_2: true,
      isValue3Empty_3: true,
      isValue3Empty_4: true,
      listNum: null,
      loading: false,
      dataLoaded: false, // 表格数据是否加载完成的状态
      pagefenye: false,//点击分页 滚动条为0
      collapseItems: null,
      popoverData: [],// 存储获取到的数据
      contentData: "",// 存储获取到的数据
      refundData: "",// 存储获取到的数据
      isEditing: [],
      hoveredId: null, //鼠标悬停时候的id
      backgroundColor: '', // 背景色
      selectedId: '',
      resData: null,
      referenceClicked: false, // 初始状态为关闭
      scrollTopValue: 0,// 保存滚动条位置
      tab_index: 0,

      showNameColumn: true,
      showNameColumn_box: false,
      showNameColumn_box_one: false,
      showNameColumn_box_two: false,
      showNameColumn_box_three: false,
      ok_Evt: false,
      activeTab: '1',
      activeNames: [], // 存储当前打开的折叠项的名称
      poop: null,
      isPopoverVisible: false,
      visible: false,
      orders: ['descending', 'ascending', null],
      roles: null, //权限字段
      disabled: false,
      selectedValuesList: [],
      visible_1: false,
      visible_2: false,
      visible_3: false,
      startDate0: null,
      endDate0: null,
      startDate1: null,
      endDate1: null,
      startDate2: null,
      endDate2: null,
      startDate3: null,
      endDate3: null,
      unset: [],
      savedId: null,
      dialogVisible: false,
      SignKey: null,
      currentTarget: null,


      // 新增结算单相关状态变量
      settlementCurrentTarget: null,
      settlementSignKey: ''
    };
  },
  created() {
    this.loading = true
    ERPListApi({}).then((res => {
      this.tableData = res.data,

          this.unset = res.unset,
          this.total = res.total,
          this.currentPage1 = res.page - 0;
      this.totalRow = res.totalRow;
      this.loading = false;
    })),


        DropdownApi({}).then((res => {
          this.set_of = res.data.sign
          this.assistant_id = res.data.assistant
          this.first_sales_id = res.data.first_sales
          this.charge = res.data.charge
          this.group = res.data.group
        }))

    StatusApi({}).then((res => {
      this.roles = res.user.role
      // this.roles = 5
      // role字段 6管理员 3市场 4助理  5
      localStorage.setItem('role', this.roles);
    }))

    SearchApi({}).then((res => {
      this.options1 = res.data.type
    }))
    //监听鼠标按下抬起事件
    window.addEventListener("keydown", this.handKeyCode, true);

    window.addEventListener('keyup', this.handKeyEvt);
  },
  beforeDestroy() {
    // 在组件生命周期结束的时候销毁
    window.removeEventListener("keydown", this.handKeyCode, true);
    window.removeEventListener("keyup", this.handKeyEvt, false);
  },
  mounted() {

    window.addEventListener("scroll", (e) => this.imgScrollEvt(e), true);
  },
  computed: {
    sortOrders() {
      // 根据当前排序顺序动态计算v-sort-orders的值
      return this.sortOrder ? [this.sortOrder, 'ascending', ''] : ['descending', 'ascending', ''];
    },

    //选择后颜色进行改变
    isDynamicBackground() {
      return this.value3_1 || this.value3 || this.endDate0 || this.startDate0;
    },
    isDynamicBackground1() {
      return this.value2_1 || this.value2 || this.endDate1 || this.startDate1;
    },
    isDynamicBackground2() {
      return this.value1_1 || this.value1 || this.endDate2 || this.startDate2;
    },
    isDynamicBackground3() {
      return this.value0_1 || this.value0 || this.endDate3 || this.startDate3;
    },
    hasContent() {
      const fields = [
        this.name,
        this.customer,
        this.status,
        this.back_status,
        this.pdf,
        this.invoice,
        this.sign,
        this.assistant,
        this.first_sales,
        this.charge_id,
        this.group_one,
        this.progress_remark,
        this.content_remark,
        this.refund_remark,
        this.value3_1,
        this.value3,
        this.value2_1,
        this.value2,
        this.value1_1,
        this.value1,
        this.value0_1,
        this.value0,
        this.region,
        this.type_id,
        this.endDate0,
        this.startDate0,
        this.endDate1,
        this.startDate1,
        this.endDate2,
        this.startDate2,
        this.endDate3,
        this.startDate3,
      ];

      // 检查所有字段的长度是否为0
      return fields.some(field => (field && field.length > 0));
    }
  },

  methods: {

    canView(item) {
      //1 项目进度 2市场信息 3图量安排 4产值划分 5成本统计
      if (item === 1) {
        return true;
      }
      if (item === 2) {
        if (this.roles === 8) {
          return false;
        }
        return this.roles !== 4 && this.roles !== 5;
      }
      if (item === 3) {
        return true;
      }
      if (item === 4) {
        return this.roles !== 3 && this.roles !== 4
      }
      if (item === 5) {
        if (this.roles === 8) {
          return false;
        }
        return this.roles !== 3 && this.roles !== 4 && this.roles !== 5
      }
      return false;
    },


    // 查看结算单
    viewSettlement(row) {
      this.selectedId = row.id;
      // 打开结算单查看对话框，假设类型为3
      this.openChildDialog(2, 2);
    },

    // 处理结算单拖拽过格子时的事件
    handleSettlementDragOver(event, row, index) {
      event.preventDefault();
      event.stopPropagation();

      // 获取当前格子的 DOM 元素
      const targetElement = event.target;

      // 如果之前有高亮格子，恢复其背景颜色
      if (this.settlementCurrentTarget) {
        this.settlementCurrentTarget.style.backgroundColor = '';
      }

      // 修改当前格子的背景颜色
      targetElement.style.backgroundColor = '#f9f9f9';

      // 更新当前高亮的格子
      this.settlementCurrentTarget = targetElement;
    },

    // 结算单鼠标离开事件
    handleSettlementMouseLeave(event) {
      const targetElement = event.target.closest('div');

      // 恢复默认背景颜色
      if (targetElement) {
        targetElement.style.backgroundColor = '';
      }

      // 清空当前高亮的格子
      this.settlementCurrentTarget = null;
    },

    // 处理结算单拖拽上传
    handleSettlementDrop(event, row, index) {
      event.preventDefault();
      event.stopPropagation();

      const files = event.dataTransfer.files;
      if (files.length === 0) return;

      const file = files[0];

      // 使用相同的文件校验方法
      const validation = this.validateFile(file);
      if (!validation.valid) {
        this.$message.warning(validation.message);
        return;
      }

      // 调用模拟上传并指定类型为结算单
      this.simulateUploadSuccess(file, row, index, 'settlement');
    },

    // 点击“上传结算单”时触发文件选择
    triggerSettlementFileInput(index) {
      const fileInput = this.$refs['settlementFileInput' + index];
      if (fileInput) {
        fileInput.click();
      }
    },

    // 用户选择结算单文件后触发
    onSettlementFileSelect(event, row, index) {
      this.selectedId = row.id;

      const file = event.target.files[0];
      if (!file) return;

      // 统一的文件校验
      const validation = this.validateFile(file);
      if (!validation.valid) {
        this.$message.warning(validation.message);
        // 清空 input
        event.target.value = '';
        return;
      }

      // 清空 input，避免重复选择同一文件不触发 change
      event.target.value = '';

      this.simulateUploadSuccess(file, row, index, 'settlement');
    },


    viewContract(e) {
      this.selectedId = e.id;
      this.openChildDialog(2, 1)
    },
    // 处理拖拽过格子时的事件
    handleDragOver(event, row, index) {
      event.preventDefault();
      event.stopPropagation();

      // 获取当前格子的 DOM 元素
      const targetElement = event.target;

      // 如果之前有高亮格子，恢复其背景颜色
      if (this.currentTarget) {
        this.currentTarget.style.backgroundColor = '';  // 恢复默认背景颜色
      }

      // 修改当前格子的背景颜色
      targetElement.style.backgroundColor = '#f9f9f9';  // 你可以根据需要修改颜色

      // 更新当前高亮的格子
      this.currentTarget = targetElement;
    },

    handleMouseLeave(event) {
      const targetElement = event.target.closest('div');  // 获取格子的 DOM 元素

      // 恢复默认背景颜色
      targetElement.style.backgroundColor = '';  // 恢复为默认背景颜色

      // 清空当前高亮的格子
      this.currentTarget = null;
    },

    // 处理拖拽上传
    handleDrop(event, row, index) {
      event.preventDefault();
      event.stopPropagation();

      const files = event.dataTransfer.files;
      if (files.length === 0) return;

      const file = files[0];

      // 统一的文件校验
      const validation = this.validateFile(file);
      if (!validation.valid) {
        this.$message.warning(validation.message);
        return;
      }

      this.simulateUploadSuccess(file, row, index);
    },

    // 点击“上传合同”时触发文件选择
    triggerFileInput(index) {
      const fileInput = this.$refs['fileInput' + index];
      if (fileInput) {
        fileInput.click();
      }
    },

    // 用户选择文件后触发
    onFileSelect(event, row, index) {
      this.selectedId = row.id;

      const file = event.target.files[0];
      if (!file) return;

      // 统一的文件校验
      const validation = this.validateFile(file);
      if (!validation.valid) {
        this.$message.warning(validation.message);
        // 清空 input
        event.target.value = '';
        return;
      }

      // 清空 input，避免重复选择同一文件不触发 change
      event.target.value = '';

      this.simulateUploadSuccess(file, row, index);
    },

    // ✅ 新增：统一文件校验方法
    validateFile(file) {
      const MAX_SIZE = 100 * 1024 * 1024; // 50MB

      // 检查文件大小
      if (file.size > MAX_SIZE) {
        return {
          valid: false,
          message: '文件大小不能超过 100MB'
        };
      }

      // 检查文件类型（MIME）
      const isPdfByType = file.type === 'application/pdf';

      // 检查文件扩展名（防止 MIME 类型被篡改或识别错误）
      const fileName = file.name.toLowerCase();
      const isPdfByExt = fileName.endsWith('.pdf');

      if (!isPdfByType || !isPdfByExt) {
        return {
          valid: false,
          message: '仅支持 PDF 文件'
        };
      }

      return {valid: true};
    },

    // 模拟上传成功
    async simulateUploadSuccess(file, row, index, uploadType) {
      const _this = this;
      try {
        // 🔹 1. 调用 UploadContractApi 获取签名信息
        const apiRes = await UploadContractApi({
          filename: file.name,
          // 结算单上传时添加type: 2参数
          ...(uploadType === 'settlement' && {type: 2})
        });
        // 处理响应结构
        const res = apiRes.data || apiRes;

        // 🔹 2. 校验必要字段
        if (!res.host || !res.key || !res.policy || !res.signature || !res.accessid) {
          throw new Error('上传凭证不完整，请重试');
        }
        this.SignKey = res.key;

        // 🔹 3. 构造 FormData 上传到 OSS
        const formData = new FormData();
        formData.append('OSSAccessKeyId', res.accessid);
        formData.append('policy', res.policy);
        formData.append('signature', res.signature);
        formData.append('key', res.key);
        formData.append('file', file);
        formData.append('success_action_status', '200');

        // 🔹 4. 使用 fetch 上传到 OSS
        const ossResponse = await fetch(`https://${res.host}`, {
          method: 'POST',
          body: formData
        });

        if (!ossResponse.ok) {
          const errorText = await ossResponse.text();
          throw new Error(`OSS 上传失败: ${ossResponse.status} ${errorText}`);
        }

        // 🔹 5. 调用 UploadctApi 替代 /api/pdf/finish
        const finishResponse = await UploadctApi({
          key: res.key,
          id: row.id,
          // 结算单上传时添加type: 2参数
          ...(uploadType === 'settlement' && {type: 2})
        });

        const finishData = finishResponse.data || finishResponse;
        if (finishData.code !== 1000) {
          throw new Error(finishData.msg || 'UploadctApi 返回失败');
        }

        // ✅ 设置当前日期为 MM-DD 格式
        const now = new Date();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const currentDate = `${month}-${day}`;

        // 区分设置时间字段，互不影响
        if (uploadType === 'settlement') {
          row.invoice_time = currentDate; // 结算单使用 invoice_time
        } else {
          row.pdf_time = currentDate; // 合同使用 pdf_time
        }
        // 更新视图
        _this.$set(_this.tableData, index, {...row});
      } catch (error) {
        _this.$message.error(`❌ 上传失败：${error.message || '未知错误'}`);
      }
    },


    formatDate(date) {
      if (date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
      return '';
    },


    //弹窗打开后数据修改 及时返回改变文字的颜色
    handleSaveSuccess(data) {
      if (data.success) {
        const idToFind = data.id; // 需要查找的ID
        const newNameColor = '1'; // 新的name_color 值
        // 更新 tableData 中对应ID的数据的 name_color 字段
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].id === idToFind) {
            this.$set(this.tableData[i], 'name_color', newNameColor); // 使用 $set 方法更新数据
            break; // 找到匹配的ID后跳出循环
          }
        }
        // 触发表格重新渲染
        this.$nextTick(() => {
          this.$refs.sortTable.doLayout();
        });
      } else {
        const idToFind = data.id; // 需要查找的ID
        const newNameColor = '2'; // 新的name_color 值
        // 更新 tableData 中对应ID的数据的 name_color 字段
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].id === idToFind) {
            this.$set(this.tableData[i], 'name_color', newNameColor); // 使用 $set 方法更新数据
            break; // 找到匹配的ID后跳出循环
          }
        }
        // 触发表格重新渲染
        this.$nextTick(() => {
          this.$refs.sortTable.doLayout();
        });
      }
    },


    fieldShow(val) {
      return !this.unset.some(item => item === val);
    },
    ret() {
      ERPListApi({}).then((res => {
        this.tableData = res.data,
            this.total = res.total,
            this.currentPage1 = res.page - 0;
        this.totalRow = res.totalRow;
        this.loading = false;
      }))
    },
    clearInput(e) {
      if (e == 1) {
        this.endDate0 = '';
        this.startDate0 = '';
        this.value3_1 = null;
        this.value3 = null;
        this.ret();
      } else if (e == 2) {
        this.endDate1 = '',
            this.startDate1 = '',

            this.value2_1 = null;
        this.value2 = null;
        this.ret()
      } else if (e == 3) {
        this.endDate2 = '',
            this.startDate2 = '',
            this.value1_1 = null;
        this.value1 = null;
        this.ret()
      } else if (e == 4) {
        this.endDate3 = '',
            this.startDate3 = '',
            this.value0_1 = null;
        this.value0 = null;
        this.ret()
      }
    },
    getTimestamp(option, parameter) {
      const closePopover = () => {
        this.visible = false;
        this.visible_1 = false;
        this.visible_2 = false;
        this.visible_3 = false;
      };

      let startTimestamp = 0;
      let endTimestamp = 0;
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth();
      const day = now.getDate();
      const dayOfWeek = now.getDay(); // 0 (Sunday) to 6 (Saturday)
      switch (parameter) {
        case 'today':
          startTimestamp = Math.floor(new Date(year, month, day, 0, 0, 0) / 1000);
          endTimestamp = Math.floor(new Date(year, month, day, 23, 59, 59) / 1000);
          break;
        case 'yesterday':
          const yesterday = new Date(year, month, day - 1);
          startTimestamp = Math.floor(new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 0, 0, 0) / 1000);
          endTimestamp = Math.floor(new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 23, 59, 59) / 1000);
          break;
        case 'thisWeek':
          const firstDayOfWeek = day - dayOfWeek;
          startTimestamp = Math.floor(new Date(year, month, firstDayOfWeek, 0, 0, 0) / 1000);
          endTimestamp = Math.floor(new Date(year, month, day, 23, 59, 59) / 1000);
          break;
        case 'lastWeek':
          const firstDayOfLastWeek = day - dayOfWeek - 7;
          const lastDayOfLastWeek = firstDayOfLastWeek + 6;
          startTimestamp = Math.floor(new Date(year, month, firstDayOfLastWeek, 0, 0, 0) / 1000);
          endTimestamp = Math.floor(new Date(year, month, lastDayOfLastWeek, 23, 59, 59) / 1000);
          break;
        case 'thisMonth':
          startTimestamp = Math.floor(new Date(year, month, 1, 0, 0, 0) / 1000);
          endTimestamp = Math.floor(new Date(year, month + 1, 0, 23, 59, 59) / 1000);
          break;
        case 'lastMonth':
          startTimestamp = Math.floor(new Date(year, month - 1, 1, 0, 0, 0) / 1000);
          endTimestamp = Math.floor(new Date(year, month, 0, 23, 59, 59) / 1000);
          break;
        case 'thisYear':
          startTimestamp = Math.floor(new Date(year, 0, 1, 0, 0, 0) / 1000);
          endTimestamp = Math.floor(new Date(year, 11, 31, 23, 59, 59) / 1000);
          break;
        case 'lastYear':
          startTimestamp = Math.floor(new Date(year - 1, 0, 1, 0, 0, 0) / 1000);
          endTimestamp = Math.floor(new Date(year - 1, 11, 31, 23, 59, 59) / 1000);
          break;
      }
      //根据获取的值来传递
      const fetchData = (startKey, endKey) => {
        const params = {
          [startKey]: startTimestamp,
          [endKey]: endTimestamp,
        };
        this.startDate = new Date(params[`${startKey}`] * 1000).toLocaleDateString();
        this.endDate = new Date(params[`${endKey}`] * 1000).toLocaleDateString();


        if (option == 1) {
          this.startDate0 = this.startDate
          this.endDate0 = this.endDate
        } else if (option == 2) {
          this.startDate1 = this.startDate
          this.endDate1 = this.endDate
        } else if (option == 3) {
          this.startDate2 = this.startDate
          this.endDate2 = this.endDate
        } else if (option == 4) {
          this.startDate3 = this.startDate
          this.endDate3 = this.endDate
        }
        ;

        ERPListApi({
              orField: this.orField,
              orWhere: this.order,
              page: this.currentPage1,
              name: this.name,
              status: this.status,
              group: this.group_one,
              sign: this.sign,
              assistant: this.assistant,
              first_sales: this.first_sales,
              charge: this.charge_id,
              customer: this.customer,
              customer_area: this.customer_area,
              limit: this.paginationInput,
              progress_remark: this.progress_remark,
              content_remark: this.content_remark,
              refund_remark: this.refund_remark,
              region: this.region ? this.region : '',
              type_id: this.type_id,
              back_status: this.back_status,
              pdf: this.pdf,
              invoice: this.invoice,
              sign_id: this.sign_id,
              group_id: this.group_id,
              start_time_start: this.startDate0 ? Math.floor(new Date(this.startDate0).getTime() / 1000) : '',
              start_time_end: this.endDate0 ? Math.floor(new Date(this.endDate0).setHours(23, 59, 59, 999) / 1000) : '',
              demand_time_start: this.startDate1 ? Math.floor(new Date(this.startDate1).getTime() / 1000) : '',
              demand_time_end: this.endDate1 ? Math.floor(new Date(this.endDate1).setHours(23, 59, 59, 999) / 1000) : '',
              end_time_start: this.startDate2 ? Math.floor(new Date(this.startDate2).getTime() / 1000) : '',
              end_time_end: this.endDate2 ? Math.floor(new Date(this.endDate2).setHours(23, 59, 59, 999) / 1000) : '',
              income_time_start: this.startDate3 ? Math.floor(new Date(this.startDate3).getTime() / 1000) : '',
              income_time_end: this.endDate3 ? Math.floor(new Date(this.endDate3).setHours(23, 59, 59, 999) / 1000) : '',
            }
        ).then((res) => {
          this.tableData = res.data;
          this.total = res.total;
          this.currentPage1 = res.page - 0;
          this.totalRow = res.totalRow;
          this.loading = false;
          closePopover();
        });
      };

      // 根据不同的option执行不同的逻辑
      if (option == 1) {
        fetchData('start_time_start', 'start_time_end');
      } else if (option == 2) {
        fetchData('demand_time_start', 'demand_time_end');
      } else if (option == 3) {
        fetchData('end_time_start', 'end_time_end');
      } else if (option == 4) {
        fetchData('income_time_start', 'income_time_end');
      }
      ;
    },


    queren_E() {
      this.handleData(this.value3, this.value3_1, 'start_time_start', 'start_time_end', ERPListApi, 'visible', 'startDate0', 'endDate0');
    },
    queren_Ev() {
      this.handleData(this.value2, this.value2_1, 'demand_time_start', 'demand_time_end', ERPListApi, 'visible_1', 'startDate1', 'endDate1');
    },
    queren_Evt() {
      this.handleData(this.value1, this.value1_1, 'end_time_start', 'end_time_end', ERPListApi, 'visible_2', 'startDate2', 'endDate2');
    },
    queren_Evte() {
      this.handleData(this.value0, this.value0_1, 'income_time_start', 'income_time_end', ERPListApi, 'visible_3', 'startDate3', 'endDate3');
    },
    handleData(value, value_1, startKey, endKey, apiFunction, visibleKey, startDateKey, endDateKey) {
      // 将日期转换为时间戳
      let timestampInSeconds1 = value ? Math.floor(new Date(value).getTime() / 1000) : undefined;
      let timestampInSeconds2 = value_1 ? Math.floor(new Date(value_1).getTime() / 1000) : undefined;

      // 处理数组形式的日期值
      const timeArray = Array.isArray(value) ? value : [value];
      const timestampArray = timeArray.map(timeString => timeString ? Math.floor(new Date(timeString).getTime() / 1000) : undefined);

      const timeArray1 = Array.isArray(value_1) ? value_1 : [value_1];
      const timestampArray1 = timeArray1.map(timeString => timeString ? Math.floor(new Date(timeString).getTime() / 1000) : undefined);

      // 更新 startDate 和 endDate
      this[startDateKey] = value_1 ? new Date(value_1).toLocaleDateString() : '';
      this[endDateKey] = value ? new Date(value).toLocaleDateString() : '';

      // 发送请求
      if (value && value_1) {
        // 如果两个日期都存在，发送包含开始和结束时间的请求
        Promise.all([
          apiFunction({
            [startKey]: timestampInSeconds2 || timestampArray1[0],
            [endKey]: timestampInSeconds1 || timestampArray[1]
          })
        ]).then(([res1]) => {
          this.tableData = res1.data;
          this.total = res1.total;
          this.totalRow = res1.totalRow;
          this.listNum = {totalRow: this.totalRow};
          this.currentPage1 = res1.page - 0;
        });
      } else {
        // 如果只有一个日期存在，仅发送包含该日期的请求
        let requestData = {};
        if (value) {
          requestData[endKey] = timestampInSeconds1 || timestampArray[1];
        }
        if (value_1) {
          requestData[startKey] = timestampInSeconds2 || timestampArray1[0];
        }

        apiFunction(requestData).then((res) => {
          this.tableData = res.data;
          this.total = res.total;
          this.totalRow = res.totalRow;
          this.listNum = {totalRow: this.totalRow};
          this.currentPage1 = res.page - 0;
        });
      }

      // 关闭弹出框
      this[visibleKey] = false;
    },


    minxEvt() {
      this.$nextTick(() => {
        this.showNameColumn_box = false
        this.showNameColumn_box_one = false
        this.showNameColumn_box_two = false
        this.showNameColumn_box_three = false
        this.$refs.sortTable.clearSort();

        setTimeout(res => {
          // 在这里执行需要在异步操作完成后执行的代码
          this.activeTab = '1';
          this.showNameColumn = true

        }, 10)
      })
    },
    min_boxEvt() {

      this.$nextTick(() => {
        this.showNameColumn = false
        this.showNameColumn_box_one = false
        this.showNameColumn_box_two = false
        this.showNameColumn_box_three = false
        this.$refs.sortTable.clearSort();

        setTimeout(res => {
          this.activeTab = '2';
          // 在这里执行需要在异步操作完成后执行的代码
          this.showNameColumn_box = true
        }, 10)
      })
    },
    min_oneEvt() {
      this.$nextTick(() => {
        this.showNameColumn_box = false
        this.showNameColumn = false
        this.showNameColumn_box_two = false
        this.showNameColumn_box_three = false
        this.$refs.sortTable.clearSort();

        setTimeout(res => {
          this.activeTab = '3';
          // 在这里执行需要在异步操作完成后执行的代码
          this.showNameColumn_box_one = true
        }, 10)
      })
    },
    min_twoEvt() {
      this.$nextTick(() => {
        this.showNameColumn_box_one = false
        this.showNameColumn_box = false
        this.showNameColumn = false
        this.showNameColumn_box_three = false
        this.$refs.sortTable.clearSort();
        setTimeout(res => {
          this.activeTab = '4';
          this.showNameColumn_box_two = true
        }, 10)
      })
    },
    min_box_three() {
      this.$nextTick(() => {
        this.showNameColumn_box_two = false
        this.showNameColumn_box_one = false
        this.showNameColumn_box = false
        this.showNameColumn = false
        this.$refs.sortTable.clearSort();

        // 在这里执行需要在异步操作完成后执行的代码
        setTimeout(res => {
          this.activeTab = '5';
          this.showNameColumn_box_three = true
        }, 10)
      })
    },

    handleReferenceClick() {
      this.referenceClicked = true; // 设置为已点击状态
    },


    customRowClass({row, rowIndex}) {
      if (row.status == '进行中') {
        return 'in-progress-row'
      } else if (row.status == '暂停') {
        return 'paused-row'
      } else if (row.status == '完工') {
        return 'completed-row'
      }
      return '';
    },

    huaguo(row, column, cell, event) {
      let timeoutId = null;
      let isContentVisible = false;
      event.target.addEventListener('click', () => {
        clearTimeout(timeoutId);
        if (!isContentVisible) {
          this.hoveredId = row.id; // 保存id
          // 在这里获取数据并进行相应的操作
          this.popoverData = row.progress_remark;
          this.contentData = row.content_remark;
          this.refundData = row.refund_remark;
          isContentVisible = true;
        } else {
          this.hoveredId = null; // 清除id
          this.popoverData = null;
          this.contentData = null;
          this.refundData = null;
          isContentVisible = false;
        }
      });
      this.selectedId = row.id;
    },

    showEvt() {
    },

    sevEvt() {
      this.poop = ''; // 清空输入框的内容
      this.activeName = 0;
      this.ok_Evt = false
      document.body.click()
    },
    handleAdd(type) {
      const newContent = ''; // 这里替换为你获取输入内容的方法
      const index = 0;
      // 设置展开状态
      this.activeName = index.toString();
      this.ok_Evt = true;

      // 设置焦点
      if (type == 1) {
        this.popoverData.unshift(newContent); // 在popoverData数组开头添加一个带有active属性的对象
        this.isEditing.splice(0, 0, true); // 在isEditing数组开头添加一个true值，表示编辑状态
      } else if (type == 2) {
        this.contentData.unshift(newContent);
        this.isEditing.splice(0, 0, true); // 在isEditing数组开头添加一个true值，表示编辑状态
      } else if (type === 3) {
        this.refundData.unshift(newContent); // 在refundData数组开头添加一个带有active属性的对象
        this.isEditing.splice(0, 0, true); // 在isEditing数组开头添加一个true值，表示编辑状态
      }
      if (this.remark === '') {
        // 输入框为空，恢复原始数据
        this.poop = '';
        this.isEditing.splice(0, 0, false); // 在isEditing数组开头添加一个false值，表示非编辑状态
        return; // 不发起请求，直接返回
      }
      // this.poop = ''; // 清空输入框的内容
    },
    closePopover(scope) {
      this.poop = '';
      this.activeName = 0;
      this.ok_Evt = false
      document.body.click()
      this.getList()
    },
    cancelEdit(type) {
      // 获取正确的remark值
      let remark = '';
      if (type == 1) {
        remark = this.poop;
      } else if (type == 2) {
        remark = this.poop;
      } else if (type == 3) {
        remark = this.poop;
      }
      // 发起请求
      if (remark !== '') {
        // 发起请求
        AddApi({
          id: this.hoveredId, // 使用保存的id
          type: type,
          remark: remark,
        }).then((res) => {
          if (res.code == 1000) {
            this.activeName = 0
            this.ok_Evt = false
            this.isEditing[0] = false; // 将第一个元素设置为false，表示非编辑状态
            // this.poop = ''
            document.body.click()
            this.getList()
          }
        });
      }
    },

    // startEditing(index) {
    //   this.activeName = index.toString();
    //   this.isEditing[index] = true; // 将对应的折叠项设置为编辑状态
    // },
    deleteItem(item, type) {

      this.$confirm('此操作将永久删除该文件，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        DelremarkApi({
          type: type,
          id: item.id
        }).then(res => {
          if (res.code === 1000) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            // 从相应的数据列表中移除选中的项目
            if (type === 1) {
              const index = this.popoverData.indexOf(item);
              if (index !== -1) {
                this.activeName = 0
                this.popoverData.splice(index, 1);
                this.getList()
              }
            } else if (type === 2) {
              const index = this.contentData.indexOf(item);
              if (index !== -1) {
                this.activeName = 0
                this.contentData.splice(index, 1);
                this.getList()
              }
            } else if (type === 3) {
              const index = this.refundData.indexOf(item);
              if (index !== -1) {
                this.activeName = 0
                this.refundData.splice(index, 1);
                this.getList()
              }
            }
          } else {
            this.$message.error('删除失败!');
          }
        });
      }).catch(() => {
        // 取消删除操作
      });
    },
    getProgressRemarkString(progressRemark) {
      if (Array.isArray(progressRemark) && progressRemark.length > 0) {
        return progressRemark[0].remark; // 返回数组的第一个元素的remark属性
      } else if (Array.isArray(progressRemark) && progressRemark.length === 0) {
        return ""; // 返回空字符串
      }
      return progressRemark; // 如果不是数组，则直接返回原始值
    },

    //滑动事件
    imgScrollEvt(e) {
    },

    idEvt(row, column, cell, event) {
      console.log(row, 213123);

      this.selectedId = row.id
    },
    openChildDialog(type, e) {
      if (type == 1) {
        this.$refs.childComponentRef.openDialog();
      } else {
        InfoApi({
          id: this.selectedId
        }).then((res) => {
          if (res.code == 1000) {
            this.resData = res.data
            this.$refs.childComponentRef.openDialog(this.resData, e);
          }
        });
      }
    },


    openChildDialog_box() {
      this.$refs.detailsComponentRef.openDialog_box();
    },

    //分页
    handleCurrentChange(res) {
      this.loading = true
      setTimeout(() => {
        this.getList();
        this.loading = false
      }, 100)
    },
    //列表排序
    sortChangeEvt(row) {
      if (row.order == "ascending") {
        this.order = "asc";
        this.orField = row.prop;
      } else if (row.order == "descending") {
        this.order = "desc";
        this.orField = row.prop;
      } else if (row.order == null) {
        this.order = "";
        this.orField = '';
      }
      this.getList();
    },
    //按下键盘事件
    handKeyCode(e) {
      e = e || window.event;
      if (e.keyCode == 78) {
      }
      if (e.keyCode == 70) {
        this.count++;
        if (this.count == 1) {
          this.showForm = true
        } else {
          this.showForm = false
        }
        setTimeout(() => {
          this.count = 0;
        }, 500);
      }
      //Page Up 翻页
      if (e.keyCode == 34) {
        this.loading = true
        e.preventDefault();
        delay(() => {
          this.currentPage1++;
          this.getList()
        }, 300);
      }
      // Page Down向后分页
      if (e.keyCode == 33) {
        this.loading = true
        delay(() => {
          if (this.currentPage1 <= 1) {
            this.currentPage1 = 1;
          } else {
            this.currentPage1--;
          }
          this.getList()
        }, 300);
      }
    },


    getSummaries(param) {
      const {columns, tableData} = param;
      const sums = [];
      columns.forEach((column, index) => {
        for (let key in this.totalRow) {
          if (column.property == key) {
            sums[index] = this.totalRow[key];
          }
        }
        if (index == 0) {
          sums[index] = "总和";
          return;
        }
      });
      return sums;
    },

    limitEvt() {
      this.getList();
    },
    //客户区域
    customer_box(selectedValues) {
      this.region = selectedValues[0];
      this.getList();
    },

    //项目进度
    status_box(selectedValues) {
      this.status = selectedValues[0];
      this.getList();
    },
    //回款情况
    handleSelectionChange(value) {
      this.back_status = value; // 更新back_status为选中的值
      this.getList();
    },
    pdfChange(value) {

      this.pdf = value; // 更新pdf为选中的值
      this.getList();
    },
    invoiceChange(value) {
      this.invoice = value; // 更新pdf为选中的值
      this.getList();
    },

    //签单人选择下拉内容
    signChange(value) {
      this.sign = value;
      this.getList()
    },
    //小组选择下拉内容
    groupChange(value) {
      this.group_one = value;
      this.getList()
    },
    //翻译选择下拉内容
    charge_idChange(value) {
      this.charge_id = value;
      this.getList()
    },
    //维护人选择下拉内容
    assistantChange(value) {
      this.assistant = value;
      this.getList()
    },
    first_salesChange(value) {
      this.first_sales = value;
      this.getList()
    },

    //客户类型
    Customer_type(value) {
      this.type_id = value;
      this.getList();
    },

    activeTextEvt(res) {
      this.activeId = res.id;
    },
    activeEvt(res) {
      let str = "";
      this.num = res
      switch (this.num) {
        case "1":
          str = "进行中";
          break;
        case "2":
          str = "暂停";
          break;
        case "3":
          str = "完工";
          break;
      }
      ScheduleApi({
        id: this.activeId,
        status: this.num,
      }).then((e) => {
        this.tableData = this.tableData.map((val) => {
          if (val.id == this.activeId) {
            val.status = str;
          }
          return val;
        });
      });
    },

    //获取页面数据
    getList() {

      let date1 = {
        start: this.value2[0],
        end: this.value2[1],
      };
      var startTimestamp1 = Math.floor(date1.start / 1000);
      var endTimestamp1 = Math.floor(date1.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate1 = new Date(endTimestamp1 * 1000);
      lastDate1.setHours(23, 59, 59);
      endTimestamp1 = Math.floor(lastDate1.getTime() / 1000);

      let date2 = {
        start: this.value3[0],
        end: this.value3[1],
      };
      var startTimestamp2 = Math.floor(date2.start / 1000);
      var endTimestamp2 = Math.floor(date2.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate2 = new Date(endTimestamp2 * 1000);
      lastDate2.setHours(23, 59, 59);
      endTimestamp2 = Math.floor(lastDate2.getTime() / 1000);

      let date3 = {
        start: this.value1[0],
        end: this.value1[1],
      };
      var end_time_start = Math.floor(date3.start / 1000);
      var end_time_end = Math.floor(date3.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate3 = new Date(end_time_end * 1000);
      lastDate3.setHours(23, 59, 59);
      end_time_end = Math.floor(lastDate3.getTime() / 1000);

      let date4 = {
        start: this.value0[0],
        end: this.value0[1],
      };
      var income_time_start = Math.floor(date4.start / 1000);
      var income_time_end = Math.floor(date4.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate4 = new Date(income_time_end * 1000);
      lastDate4.setHours(23, 59, 59);
      income_time_end = Math.floor(lastDate4.getTime() / 1000);


      this.loading = true
      let data = {
        orField: this.orField,
        orWhere: this.order,
        page: this.currentPage1,
        name: this.name,

        status: this.status,
        // end_time: this.end_time,
        // demand_time: this.demand_time,
        group: this.group_one,
        sign: this.sign,
        assistant: this.assistant,
        first_sales: this.first_sales,
        charge: this.charge_id,
        customer: this.customer,
        customer_area:this.customer_area,
        limit: this.paginationInput,
        progress_remark: this.progress_remark,
        content_remark: this.content_remark,
        refund_remark: this.refund_remark,
        region: this.region ? this.region : '',
        type_id: this.type_id,

        back_status: this.back_status,
        pdf: this.pdf,
        invoice: this.invoice,
        sign_id: this.sign_id,
        group_id: this.group_id,
        start_time_start: this.startDate0 ? Math.floor(new Date(this.startDate0).getTime() / 1000) : '' || this.value3_1 ? Math.floor(this.value3_1 / 1000) : '',
        start_time_end: this.endDate0 ? Math.floor(new Date(this.endDate0).setHours(23, 59, 59, 999) / 1000) : '' || this.value3 ? Math.floor(this.value3 / 1000) : '',

        demand_time_start: this.startDate1 ? Math.floor(new Date(this.startDate1).getTime() / 1000) : '' || this.value2_1 ? Math.floor(this.value2_1 / 1000) : '',
        demand_time_end: this.endDate1 ? Math.floor(new Date(this.endDate1).setHours(23, 59, 59, 999) / 1000) : '' || this.value2 ? Math.floor(this.value2 / 1000) : '',
        end_time_start: this.startDate2 ? Math.floor(new Date(this.startDate2).getTime() / 1000) : '' || this.value1_1 ? Math.floor(this.value1_1 / 1000) : '',
        end_time_end: this.endDate2 ? Math.floor(new Date(this.endDate2).setHours(23, 59, 59, 999) / 1000) : '' || this.value1 ? Math.floor(this.value1 / 1000) : '',
        income_time_start: this.startDate3 ? Math.floor(new Date(this.startDate3).getTime() / 1000) : '' || this.value0_1 ? Math.floor(this.value0_1 / 1000) : '',
        income_time_end: this.endDate3 ? Math.floor(new Date(this.endDate3).setHours(23, 59, 59, 999) / 1000) : '' || this.value0 ? Math.floor(this.value0 / 1000) : '',
      };
      ERPListApi(data).then((res) => {
        this.tableData = res.data;
        this.total = res.total;
        this.totalRow = res.totalRow;
        this.listNum = {
          totalRow: this.totalRow
        };
        this.currentPage1 = res.page - 0;
        this.dataLoaded = true; // 数据加载完成，修改dataLoaded的状态
        // this.pagefenye = true;  //点击分页 滚动条为0
        // let as = document.querySelector('.el-table__body-wrapper')
        // as.scrollTop = 0
        // this.imgScrollEvt(as)
        this.loading = false;

      });

    },

    //导出excel
    excelEvt() {
      let date1 = {
        start: this.value2[0],
        end: this.value2[1],
      };
      var startTimestamp1 = Math.floor(date1.start / 1000);
      var endTimestamp1 = Math.floor(date1.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate1 = new Date(endTimestamp1 * 1000);
      lastDate1.setHours(23, 59, 59);
      endTimestamp1 = Math.floor(lastDate1.getTime() / 1000);

      let date2 = {
        start: this.value3[0],
        end: this.value3[1],
      };
      var startTimestamp2 = Math.floor(date2.start / 1000);
      var endTimestamp2 = Math.floor(date2.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate2 = new Date(endTimestamp2 * 1000);
      lastDate2.setHours(23, 59, 59);
      endTimestamp2 = Math.floor(lastDate2.getTime() / 1000);

      let date3 = {
        start: this.value1[0],
        end: this.value1[1],
      };
      var end_time_start = Math.floor(date3.start / 1000);
      var end_time_end = Math.floor(date3.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate3 = new Date(end_time_end * 1000);
      lastDate3.setHours(23, 59, 59);
      end_time_end = Math.floor(lastDate3.getTime() / 1000);

      let date4 = {
        start: this.value0[0],
        end: this.value0[1],
      };
      var income_time_start = Math.floor(date4.start / 1000);
      var income_time_end = Math.floor(date4.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate4 = new Date(income_time_end * 1000);
      lastDate4.setHours(23, 59, 59);
      income_time_end = Math.floor(lastDate4.getTime() / 1000);


      this.loading = true
      let data = {
        orField: this.orField,
        orWhere: this.order,
        page: this.currentPage1,
        name: this.name,
        status: this.status,
        group: this.group_one,
        sign: this.sign,
        assistant: this.assistant,
        first_sales: this.first_sales,
        charge: this.charge_id,
        customer: this.customer,
        customer_area:this.customer_area,
        limit: this.paginationInput,
        progress_remark: this.progress_remark,
        content_remark: this.content_remark,
        refund_remark: this.refund_remark,
        region: this.region ? this.region : '',
        type_id: this.type_id,
        back_status: this.back_status,
        pdf: this.pdf,
        invoice: this.invoice,
        sign_id: this.sign_id,
        group_id: this.group_id,

        start_time_start: this.startDate0 ? Math.floor(new Date(this.startDate0).getTime() / 1000) : '' || this.value3_1 ? Math.floor(new Date(this.value3_1).getTime() / 1000) : '',
        start_time_end: this.endDate0 ? Math.floor(new Date(this.endDate0).setHours(23, 59, 59, 999) / 1000) : '' || this.value3 ? Math.floor(new Date(this.value3).setHours(23, 59, 59, 999) / 1000) : '',

        demand_time_start: this.startDate1 ? Math.floor(new Date(this.startDate1).getTime() / 1000) : '' || this.value2_1 ? Math.floor(new Date(this.value2_1).getTime() / 1000) : '',
        demand_time_end: this.endDate1 ? Math.floor(new Date(this.endDate1).setHours(23, 59, 59, 999) / 1000) : '' || this.value2 ? Math.floor(new Date(this.value2).setHours(23, 59, 59, 999) / 1000) : '',

        end_time_start: this.startDate2 ? Math.floor(new Date(this.startDate2).getTime() / 1000) : '' || this.value1_1 ? Math.floor(new Date(this.value1_1).getTime() / 1000) : '',
        end_time_end: this.endDate2 ? Math.floor(new Date(this.endDate2).setHours(23, 59, 59, 999) / 1000) : '' || this.value1 ? Math.floor(new Date(this.value1).setHours(23, 59, 59, 999) / 1000) : '',

        income_time_start: this.startDate3 ? Math.floor(new Date(this.startDate3).getTime() / 1000) : '' || this.value0_1 ? Math.floor(new Date(this.value0_1).getTime() / 1000) : '',
        income_time_end: this.endDate3 ? Math.floor(new Date(this.endDate3).setHours(23, 59, 59, 999) / 1000) : '' || this.value0 ? Math.floor(new Date(this.value0).setHours(23, 59, 59, 999) / 1000) : '',

        excel: 1,
        activeTab: this.activeTab,
      }
      let genExcel = false;
      if (genExcel == false) {
        ERPListApi(data).then((res) => {
          this.loading = false
          window.location.href = res
          genExcel = true
        });
      } else if (genExcel == true) {
        alert('正在生成数据请勿重复请求')
      }
    },
    //清除数据
    cleanUpEvt() {
      // 清空其他变量和重置表格数据
      this.sign = '';
      this.customer = '';
      this.end_time = '';
      this.demand_time = '';
      this.name = '';
      this.value0 = '';
      this.value0_1 = '';
      this.value1 = '';
      this.value1_1 = '';
      this.value2 = '';
      this.value2_1 = '';
      this.value3 = '';
      this.value3_1 = '';
      this.type_id = '';
      this.region = '';
      this.back_status = null;
      this.pdf = null;
      this.invoice = null
      this.status = null;
      this.assistant = '';
      this.first_sales = '';
      this.charge_id = '';
      this.group_one = '';
      this.sign_id = null;
      this.region = null;
      this.progress_remark = '';
      this.content_remark = '';
      this.refund_remark = '';
      this.currentPage1 = 1;
      this.paginationInput = 95;

      this.startDate0 = '';
      this.endDate0 = '';
      this.startDate1 = '';
      this.endDate1 = '';
      this.startDate2 = '';
      this.endDate2 = '';
      this.startDate3 = '';
      this.endDate3 = '';
      // 清除排序状态和样式
      this.$refs.sortTable.clearSort();

      this.loading = true
      ERPListApi().then((res) => {
        this.tableData = res.data;
        this.currentPage1 = res.page - 0;
        this.total = res.total;
        this.totalRow = res.totalRow;
        this.loading = false
      });
    },

  },
  watch: {
    'value3': function (newVal, oldVal) {
      this.isValue3Empty_1 = !newVal;
    },
    'value2': function (newVal, oldVal) {
      this.isValue3Empty_2 = !newVal;
    },
    'value1': function (newVal, oldVal) {
      this.isValue3Empty_3 = !newVal;
    },
    'value0': function (newVal, oldVal) {
      this.isValue3Empty_4 = !newVal;
    },
  }

};
</script>

<style lang="less" scoped>
@import url("../style/Media_Query.less");

.el-main {
  margin-left: 220px;
  /* 与左侧项目管理列表的宽度保持一致 */
  padding: 0px;
  /* 添加一些内边距，使内容不紧贴在边缘 */
  margin-top: 60px;
}

/deep/ .el-submenu__title {
  height: 39px !important;
  line-height: 39px !important;
  list-style: none;
}

.edit /deep/ .el-icon-arrow-down:before {
  content: "";
}

.edit {
  // width: 1000px;
  height: 40px;
  display: flex;

  div {
    height: 26px;
    cursor: pointer;
  }

  .el-input {
    width: 137px;
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    width: 137px;
    margin-left: 5px;
  }

  span {
    // width: 69px;/
    height: 26px;
    font-size: 12px;
    // border: 1px solid #589ff9;
    line-height: 26px;
    color: #589ff9;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/ .el-input__inner {
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    font-size: 12px;
    padding-left: 10px;
    border: 1px solid #888a8f;
  }

  /deep/ .el-input__icon {
    line-height: 0px;
  }
}

/deep/ .el-table th.el-table__cell {
  background: #dce6ee;
}

.pagination_box {
  min-width: 500px;
  display: flex;
  // align-items: center;
  justify-content: flex-end;
  position: absolute;
  right: 1px;
  z-index: 999;
}

/deep/ .el-tabs--border-card {
  border: none;
}

/deep/ .el-tabs--border-card > .el-tabs__content {
  padding: 0 !important;
}

/deep/ .el-table__body-wrapper {
  overflow: auto;
}

/deep/ .el-table__footer-wrapper {
  position: fixed;
  top: 140px;
  z-index: 111;
  height: 35px;
  background-color: #fff;
  width: calc(100% - 178px);
}

.mainx {
  margin-top: 50px;
}

.span_box {
  position: absolute;
  left: 1px;
  top: 80px;
  height: 47px;
  width: 315px;
  background: #fff;
  z-index: 120;
  font-size: 14px;
  line-height: 47px;
  text-align: left;
  padding-left: 13px;
}

/deep/ .el-table th.el-table__cell {
  background: #f5f7fa;
}

/deep/ .el-tabs__header {
  width: 100%;
}

/deep/ .el-table__footer-wrapper .gutter {
  background: #f5f7fa;
  border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;

}

.el-menu {
  border: none;
}

/* 添加一个新的类来将总计行移动到最上方 */
.move-top .el-table__summary-cell {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  /* 根据需要调整背景颜色、字体样式等 */
}

/deep/ .el-table__fixed-footer-wrapper {
  display: none;
}

/deep/ .el-badge__content.is-fixed {
  display: none;
}

/deep/ .el-tabs__item {
  border-radius: 3px 3px 0px 0px;
  background: #d9d9d9;
  margin-left: 4px;
  color: #979797;
  font-size: 12px;
}

/deep/ .el-tabs__active-bar {
  display: none;
}

/deep/ .el-tabs__item {
  padding: 0;
  width: 105px;
  height: 32px;
  line-height: 32px;
}

/deep/ .el-tabs__item.is-active {
  background: #fff;
  border: 1px solid #d9d9d9;
  color: #000;
  border-bottom: none;
}

/deep/ .el-table__footer-wrapper tbody td.el-table__cell {
  background: #fff;
  border: none;
}

/deep/ .el-table__footer-wrapper .gutter {
  background: #fff !important;
}

//修改tabs的下划线 以及颜色
/deep/ .el-tabs__nav-wrap::after {
  height: 0;
  border: 1px solid #d9d9d9;
}

/deep/ .el-tabs__nav {
  transform: translateY(1px) !important;
}

/deep/ .el-table th.el-table__cell > .cell {
  color: #333333;
  font-size: 12px;
  height: 23px;
}

/deep/ .el-table td.el-table__cell div {
  font-size: 12px;
}

/deep/ ::placeholder {
  color: #e5e5e5;
  /* 这里替换为你想要的颜色值 */
  margin-left: 5px !important;
}

/deep/ .edit.el-input--suffix {
  width: 137px;
}


.maxs {
  background: #f00 !important;
}

/deep/ .el-dialog__body {
  padding: 0 !important;
}

/deep/ .el-collapse-item {
  width: 490px !important;
}

.amount_to {
  position: relative;
  top: 55px;
  z-index: 111;
  width: 100%;
  height: 50px;
  display: flex;

  div {
    width: 68px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  div:nth-child(1) {
    margin-left: 10px;
  }

  div:nth-child(2) {
    margin-left: 80px;
  }

  div:nth-child(3) {
    margin-left: 20px;
  }

  div:nth-child(4) {
    margin-left: 10px;
  }

  div:nth-child(5) {
    margin-left: 10px;
  }

  div:nth-child(6) {
    margin-left: 25px;
  }

  div:nth-child(7) {
    margin-left: 10px;
  }

  div:nth-child(8) {
    margin-left: 10px;
  }
}

/deep/ .el-collapse-item__header div {
  min-width: 200px;
}

/deep/ .el-collapse-item__header {
  cursor: auto;
}

.el-icon-delete {
  position: absolute;
  right: 40px;
}

.edit .el-cascader {
  line-height: 25px;
  margin-left: 6px
}

.edit.el-cascader /deep/ .el-input__inner {
  height: 27px !important;
  min-width: 137px !important;
}

/deep/ .el-cascader__tags {
  flex-wrap: nowrap !important;
}

.custom_box /deep/ .el-cascader-menu__wrap el-scrollbar__wrap {
  height: 340px !important;
}

.your-css-class_box {
  background-color: #bcd9f8d4 !important;

  /deep/ .el-range-editor--mini .el-range-input {
    background-color: #f00 !important;
  }

}

/deep/ .caret-wrapper {
  height: 23px !important;

  .ascending {
    top: -2px !important;

  }

  .descending {
    bottom: 1px !important;
  }
}

/deep/ .el-table .el-table__row .hover-underline {
  display: none;
}

/deep/ .el-table .el-table__row:hover .hover-under {
  text-decoration: underline !important;
}

/deep/ .el-table .el-table__row:hover .hover-underline {
  display: block !important;
}

/* CSS样式 */
/deep/ .el-table .in-progress-row {
  // background-color: #f00 !important; /* 设置红色背景 */
}

/deep/ .el-table .paused-row {
  // background-color: #00f !important; /* 设置蓝色背景 */
}

/deep/ .el-table .completed-row .is-left {
  background-color: #e5e5e5 !important;
  /* 设置绿色背景 */
}


.white_over {
  white-space: nowrap;
  overflow: hidden;
  font-size: 14px !important;
}

/deep/ .edit .vip .el-input__inner {
  background-color: #bcd9f8d4 !important;
}

/deep/ .vip .el-input__inner {
  background-color: #bcd9f8d4 !important;
}

.btn2 {
  display: flex;
  align-items: center;

}

.btn2 button {
  outline: none;
  border: 1px solid #d1d1d1;
  margin: 0 2px;
  /* 添加这一行 */
  width: 100px;
  height: 35px;
  cursor: pointer;
  font-size: 14px;
}

.btn2 button.active {
  border-bottom: none;
  outline: none;
  background-color: #fff;
}

.white_over_one i {
  display: none;
}

.project_one:hover i {
  display: inline;
}

.input-list {
  z-index: 11111
}

/deep/ .el-collapse-item__header.is-active {
  display: none,
}


/deep/ .el-icon-caret-bottom {
  line-height: 2 !important;
}

/deep/ .el-table .el-table__cell {
  padding: 12.5px 0 !important;
}


/deep/ .project_ect {
  background: #accde0 !important;
}

//项目管理列的颜色
/deep/ .project_one {
  background: #e1feea !important;
}

/deep/ .project_shijian {
  background: #d4d0f5 !important;
}

/deep/ .project_two {
  background: #c0ddf5 !important;
}

//市场信息列颜色
/deep/ .project_three {
  background: #eee8b6 !important;
}


//成本统计列的颜色
/deep/ .lie_one {
  background: #e1feea !important;
}

/deep/ .lie_two {
  background: #fefae1 !important;
}

/deep/ .lie_three {
  background: #fbe1fe !important;
}


//成本统计列合计的颜色
/deep/ .el-table__footer tbody tr .lie_one {
  background: #fff !important;
}

/deep/ .el-table__footer tbody tr .lie_two {
  background: #fff !important;
}

/deep/ .el-table__footer tbody tr .lie_three {
  background: #fff !important;
}

//项目管理合计列的颜色{}
/deep/ .el-table__footer tbody tr .project_one {
  background: #fff !important;
}

/deep/ .el-table__footer tbody tr .project_ect {
  background: #fff !important;
}

/deep/ .el-table__footer tbody tr .project_shijian {
  background: #fff !important;
}

/deep/ .el-table__footer tbody tr .project_two {
  background: #fff !important;
}

/deep/ .el-table__footer tbody tr .project_three {
  background: #fff !important;
}

//table  固定头部的颜色
/deep/ .el-table th.el-table__cell {
  background: #fff !important;
}


.el-input__icon.el-icon-circle-close {
  opacity: 0;
  transition: opacity 0.3s;
}

.el-input:hover .el-input__icon.el-icon-circle-close {
  opacity: 1;
}

/deep/ .sousuo {
  margin: 90px 0 0 325px !important;
  width: 1400px;
}

placeholder {
  color: #f00;
}

/deep/ .sousuo .el-dialog__body {
  font-size: 13px !important;
}

/deep/ .el-table .popover_three {
  padding: 0px !important;
}

/deep/ .el-table .popover_three .cell {
  background: #fff;
}

/deep/ .hover-row .popover_three .cell {
  background-color: #f9f9f9 !important; /* Element Plus 默认的 hover 蓝色背景 */
  /* 你也可以自定义颜色，比如 #e6f7ff 或 #f0f8ff */

  div {
    background-color: #f9f9f9 !important; /* Element Plus 默认的 hover 蓝色背景 */
  }
}


</style>
<style>
.your-css-class_box .el-range-input {
  background-color: #8fc6ff00 !important;
}

.el-picker-panel__sidebar button:nth-child(4) {
  margin-bottom: 30px;
}

.el-tooltip__popper.is-dark {
  background-color: #589ff9 !important;
}

.el-tooltip__popper .popper__arrow {
  display: none !important;
}

.popover_one {
  padding: 0px !important;
  left: 920px !important;
  border-radius: 7px !important;
}

.popover_one div {
  color: #000 !important;
  background: #fff !important;
}

/deep/ .popover_one.is-dark {
  background-color: #fff !important;
  padding: 0px !important;
  z-index: 9999;
}


.dynamic-background input {
  background-color: #589ff9;
}


</style>



// WEBPACK FOOTER //
// src/src/index.vue